var userProfileEdit = (function () {
    function userProfileEdit(container, changePasswordUrl, toteRoleTxt, playerTxt, betBrokerTxt, operatorRole, runnerRole, getInterfacesUrl) {
        var _this = this;
        this.uiElements = {
            container: null
        };
        this.uiElements.container = $(container);
        this.changePasswordUrl = changePasswordUrl;
        this.toteRoleTxt = toteRoleTxt;
        this.playerText = playerTxt;
        this.betBrokerRoleTxt = betBrokerTxt;
        this.operatorText = operatorRole;
        this.runnerText = runnerRole;
        this.getInterfaceListUrl = getInterfacesUrl;
        var self = this;
        this.uiElements.container.on("click", ".changePasswordUrl", function () {
            _this.changePasswordClick();
        });
        this.uiElements.container.on("click", ".role-radio", function (e) {
            var val = $(e.target).closest(".role-radio").attr("data-role-text");
            var $self = _this;
            var $userInterface = _this.uiElements.container.find(".user-interface");
            var $playeragent = _this.uiElements.container.find(".player-agent");
            var $playerShowHide = _this.uiElements.container.find(".player-show");
            $.get(_this.getInterfaceListUrl, { role: val }, function (data) {
                $self.updateDropdown($userInterface.find("select"), data);
            });
            if (val == _this.toteRoleTxt || val == _this.betBrokerRoleTxt || val == _this.runnerText || val == _this.operatorText) {
                $userInterface.toggle(true);
            }
            else {
                $userInterface.toggle(false);
            }
            if (val == _this.playerText) {
                $playeragent.toggle(true);
                $playerShowHide.toggle(true);
                _this.clearInputs($playerShowHide, false);
            }
            else {
                $playeragent.toggle(false);
                $playerShowHide.toggle(false);
                _this.clearInputs($playerShowHide, true);
            }
        });
        this.uiElements.container.on("click", "input[type='submit']:not('.full-submit')", function (e) {
            e.preventDefault();
            var $form = $('form', _this.uiElements.container);
            if (!$form.valid())
                return;
            var params = $form.serialize();
            var postUrl = $form.attr('action');
            $.post(postUrl, params).done(function (data) {
                _this.uiElements.container.html(data);
                site.validators.refreshValidators(_this.uiElements.container);
            });
        });
    }
    userProfileEdit.prototype.updateDropdown = function (dropdown, selectList) {
        var $dropdown = $(dropdown);
        var value = $dropdown.val();
        $dropdown.val("");
        $dropdown.html("");
        $.each(selectList, function (ind, val) {
            $dropdown.append($("<option></option>").val(val.value).text(val.text));
        });
        $dropdown.val(value);
    };
    userProfileEdit.prototype.clearInputs = function ($container, clear) {
        if (clear) {
            var $inputs = $container.find(":input");
            $.each($inputs, function (ind, val) {
                $(val).val('');
            });
        }
    };
    userProfileEdit.prototype.changePasswordClick = function () {
        var dialogSettings = new appSaveFormDialogOptions();
        dialogSettings.title = "Change Password";
        dialogSettings.saveBtnText = "Change Password";
        site.dialogs.saveFormDialog(this.changePasswordUrl, dialogSettings);
    };
    return userProfileEdit;
}());
var balanceHandler = (function () {
    function balanceHandler(args) {
        this.uiElements = {
            container: null,
            listContainer: null,
            dateType: null,
            dateFilterContainer: null,
            okBtn: null
        };
        this.customTypeValue = "Custom";
        this.args = args;
        this.uiElements.container = $(this.args.container);
        this.uiElements.listContainer = $(".items-container", this.uiElements.container);
        this.uiElements.dateType = $("#BalanceDateType", this.uiElements.container);
        this.uiElements.okBtn = $("#okBtn", this.uiElements.container);
        this.uiElements.dateFilterContainer = $(".filters", this.uiElements.container);
        $(".datepicker").datepicker({ dateFormat: "mm/dd/yy" });
        this.subscribeToEvents();
    }
    balanceHandler.prototype.subscribeToEvents = function () {
        var _this = this;
        $('body').on('click', function (e) {
            $('.warning-toggle').each(function () {
                if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                    $(this).popover('hide');
                }
            });
        });
        $("button.warning-toggle").click(function (e) {
            e.preventDefault();
        });
        $(".warning-toggle", this.uiElements.container).popover({
            html: true,
            container: this.args.container,
            content: function () {
                return $(this).next(".warning-content").html();
            }
        });
        this.uiElements.okBtn.click(function (e) {
            _this.refreshList();
        });
        this.uiElements.dateType.change(function (e) {
            var val = _this.uiElements.dateType.val();
            if (val == _this.customTypeValue) {
                _this.uiElements.dateFilterContainer.toggle(true);
            }
            else {
                _this.uiElements.dateFilterContainer.toggle(false);
                _this.uiElements.container.find(".datepicker").each(function (index, el) {
                    $(el).val('');
                });
                _this.refreshList();
            }
        });
        this.uiElements.container.on("click", "[data-bookmaker-id]", function (e) {
            e.preventDefault();
            var $lnk = $(e.target);
            var bookmakerId = $lnk.attr("data-bookmaker-id");
            var betbrokerId = $lnk.attr("data-bet-broker-id");
            var balance = $lnk.attr("data-balance");
            var cutterId = $lnk.attr("data-cutter-id");
            var dialogOptions = {
                fetchParams: { bookmakerId: bookmakerId, betBrokerId: betbrokerId, cutterId: cutterId, runningBalance: balance },
                saveBtnText: "Apply",
                title: "Log Payment/Payout"
            };
            appSaveFormDialog(_this.args.payoutUrl, dialogOptions).done(function () { return _this.refreshList(); });
        });
        new raceResultsHandler(this.args.container, function () {
            _this.refreshList();
        }, this.args.getResultsUrl);
    };
    balanceHandler.prototype.refreshList = function () {
        var _this = this;
        $.get(this.args.getListUrl, { BalanceDateType: this.uiElements.dateType.val(), StartDate: $("#StartDate", this.uiElements.container).val(), EndDate: $("#EndDate", this.uiElements.container).val() })
            .done(function (data) {
            _this.uiElements.listContainer.html(data);
            $(".warning-toggle", _this.uiElements.container).popover({
                html: true,
                container: _this.args.container,
                content: function () {
                    return $(this).next(".warning-content").html();
                }
            });
        });
    };
    return balanceHandler;
}());
var balanceHandlerArgs = (function () {
    function balanceHandlerArgs() {
    }
    return balanceHandlerArgs;
}());
var betBrokerHistory = (function () {
    function betBrokerHistory(container, getListUrl, savePayloadUrl, exportUrl, editBetRecommendationUrl, updateStatusUrl) {
        this.uiElements = {
            container: null,
            listContainer: null,
            formElement: null,
            dateFilterContainer: null,
            okBtn: null,
            dateType: null,
            statusContainer: null,
            exportBtn: null
        };
        this.customTypeValue = "Custom";
        this.uiElements.container = $(container);
        this.uiElements.listContainer = $(".list-items", this.uiElements.container);
        this.uiElements.formElement = $("form", this.uiElements.container);
        this.uiElements.dateFilterContainer = $(".filters", this.uiElements.container);
        this.uiElements.dateType = $("#BalanceDateType", this.uiElements.container);
        this.uiElements.okBtn = $("#okBtn", this.uiElements.container);
        this.uiElements.exportBtn = $("#exportBtn", this.uiElements.container);
        this.uiElements.statusContainer = $(".status-container", this.uiElements.container);
        this.exportUrl = exportUrl;
        this.editBetRecommendationUrl = editBetRecommendationUrl;
        this.updateStatusUrl = updateStatusUrl;
        var onSelectFunction = function (dateText, obj) {
            var $el = $(obj.input);
            $($el.attr("data-id")).val(dateText);
        };
        $(".datepicker").datepicker({ dateFormat: "mm/dd/yy", onSelect: onSelectFunction });
        this.subscribeToEvents();
        this.getUrl = getListUrl;
        this.savePayloadUrl = savePayloadUrl;
    }
    betBrokerHistory.prototype.subscribeToEvents = function () {
        var _this = this;
        var self = this;
        self.uiElements.container.on("click", "#resetBtn", function (e) {
            e.preventDefault();
            _this.uiElements.dateType.val("Today");
            _this.uiElements.dateFilterContainer.toggle(false);
            _this.uiElements.container.find(".datepicker").each(function (index, el) {
                $(el).val('');
            });
            _this.updateList();
        });
        if (this.uiElements.exportBtn) {
            this.uiElements.exportBtn.click(function (e) {
                e.preventDefault();
                var $form = _this.uiElements.formElement;
                var $newForm = jQuery('<form>', {
                    'action': _this.exportUrl,
                    'method': "POST"
                });
                var array = $form.serializeArray();
                for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
                    var pair = array_1[_i];
                    $newForm.append($('<input>', {
                        'name': pair.name,
                        'value': pair.value,
                        'type': 'hidden'
                    }));
                }
                ;
                $newForm.appendTo("body").submit().remove();
            });
        }
        this.uiElements.container.on("click", "[data-edit-recommendation-id]", function (e) {
            e.preventDefault();
            var id = $(e.target).closest("a").attr("data-edit-recommendation-id");
            var dialogSettings = new appSaveFormDialogOptions();
            var betBrokerId = $("#BetBrokerId", _this.uiElements.container).val();
            var readOnly = $(e.target).attr("data-read-only");
            var bookamkerId = $(e.target).attr("data-br-bookmaker-id");
            var raceId = $(e.target).attr("data-race-id");
            dialogSettings.title = "Edit Recommendation";
            dialogSettings.saveBtnText = "Save";
            dialogSettings.fetchParams = { id: id, betBrokerId: betBrokerId, readOnlyType: readOnly, bookmakerId: bookamkerId, raceId: raceId };
            site.dialogs.saveFormDialog(_this.editBetRecommendationUrl, dialogSettings).done(function () {
                _this.updateList();
            });
        });
        this.uiElements.container.on("click", "[data-bookmaker-id]", function (e) {
            e.preventDefault();
            var $lnk = $(e.target);
            var bookmakerId = $lnk.attr("data-bookmaker-id");
            var betbrokerId = $lnk.attr("data-bet-broker-id");
            var cutterId = $lnk.attr("data-cutter-id");
            var dialogOptions = {
                fetchParams: { bookmakerId: bookmakerId, betBrokerId: betbrokerId, cutterId: cutterId },
                saveBtnText: "Apply",
                title: "Log Payment/Payout"
            };
            appSaveFormDialog(_this.savePayloadUrl, dialogOptions).done(function () { return _this.updateList(); });
        });
        this.uiElements.container.on("change", "#BalanceDateType", function () {
            var val = _this.uiElements.dateType.val();
            if (val == _this.customTypeValue) {
                _this.uiElements.dateFilterContainer.toggle(true);
            }
            else {
                _this.uiElements.dateFilterContainer.toggle(false);
                _this.uiElements.container.find(".datepicker").each(function (index, el) {
                    $(el).val('');
                });
                _this.updateList();
            }
        });
        this.uiElements.container.on("click", "#okBtn", function (e) {
            e.preventDefault();
            _this.updateList();
        });
    };
    betBrokerHistory.prototype.updateList = function () {
        var _this = this;
        var bookmakerId = $("#BookmakerId", this.uiElements.container).val();
        var betBrokerId = $("#BetBrokerId", this.uiElements.container).val();
        var cutterId = $("#CutterId", this.uiElements.container).val();
        var startDate = $("#StartDate", this.uiElements.container).val();
        var endDate = $("#EndDate", this.uiElements.container).val();
        var balanceDateType = $("#BalanceDateType", this.uiElements.container).val();
        var args = { CutterId: cutterId, BookmakerId: bookmakerId, StartDate: startDate, EndDate: endDate, BalanceDateType: balanceDateType, BetBrokerId: betBrokerId };
        $.post(this.getUrl, args, function (data) {
            _this.uiElements.listContainer.html(data);
        });
        $.post(this.updateStatusUrl, args, function (data) {
            _this.uiElements.statusContainer.html(data);
        });
    };
    return betBrokerHistory;
}());
var betEditHandler = (function () {
    function betEditHandler(args) {
        this.uiElements = {
            container: null,
            listContainer: null,
            addBtn: null,
            itemTemplate: null,
            horses: null,
            race: null,
            date: null
        };
        this._args = args;
        this.uiElements.container = $(this._args.container);
        this.uiElements.listContainer = $(".items", this.uiElements.container);
        this.uiElements.addBtn = $(".add-btn", this.uiElements.container);
        this.uiElements.itemTemplate = $("#item-template", this.uiElements.container);
        this.uiElements.horses = $("#HorseId", this.uiElements.container);
        this.uiElements.race = $("#RaceId", this.uiElements.container);
        this.uiElements.date = $(".datepicker", this.uiElements.container);
        var self = this;
        var changeDateAction = function (date) {
            self.onDateChanged(date, self);
        };
        this.uiElements.date.datepicker({
            dateFormat: "mm/dd/yy", onSelect: changeDateAction
        });
        this.subscribeToEvents();
        var $items = $("tr", this.uiElements.listContainer);
        if ($items.length == 1) {
            $("[data-delete-item]", this.uiElements.listContainer).toggle(false);
        }
        else {
            $("[data-delete-item]", this.uiElements.listContainer).toggle(true);
        }
        this.setCompletedDate();
    }
    betEditHandler.prototype.setCompletedDate = function () {
        var completedDateVal = this.uiElements.container.find("#CompletedDate");
        if (completedDateVal.val() != "" && completedDateVal.val() != undefined && completedDateVal.val() != null) {
            var utcVal = moment.utc(completedDateVal.val());
            var localVal = utcVal.local();
            console.log(localVal.format("HH:mm:ss MM/DD"));
            this.uiElements.container.find(".completed-date").text(localVal.format("HH:mm:ss MM/DD"));
        }
    };
    betEditHandler.prototype.subscribeToEvents = function () {
        var _this = this;
        var self = this;
        this.uiElements.container.on("click", "[data-delete-item]", function (e) {
            e.preventDefault();
            var options = new appConfirmDialogOptions();
            options.dialogClass = "dialog-520px-top";
            site.dialogs.confirm("Are you sure?", function (isConfirmed) {
                if (isConfirmed) {
                    $(e.target).closest("tr").remove();
                    _this.recalculateIndexes();
                }
            }, options);
        });
        self.uiElements.race.change(function () {
            $.get(self._args.getHorsesUrl, { raceId: self.uiElements.race.val() }, function (data) {
                self.updateDropdown(self.uiElements.horses, data);
            });
        });
        this.uiElements.addBtn.click(function (e) {
            _this.uiElements.listContainer.append(_this.uiElements.itemTemplate.html());
            _this.recalculateIndexes();
        });
    };
    betEditHandler.prototype.recalculateIndexes = function () {
        var $items = $("tr", this.uiElements.listContainer);
        $.each($items, function (index, $el) {
            var prefix = "Bets[" + index + "]";
            $($el).find(":input").each(function (ind, val) {
                $(val).attr("name", $(val).attr("name").replace(/Bets\[\d+\]/, prefix));
            });
        });
        if ($items.length == 1) {
            $("[data-delete-item]", this.uiElements.listContainer).toggle(false);
        }
        else {
            $("[data-delete-item]", this.uiElements.listContainer).toggle(true);
        }
    };
    betEditHandler.prototype.onDateChanged = function (dateText, self) {
        $.get(self._args.getRacesUrl, { Date: dateText == "" ? null : dateText }, function (data) {
            self.updateDropdown(self.uiElements.race, data);
        });
    };
    betEditHandler.prototype.updateDropdown = function (dropdown, selectList) {
        var $dropdown = $(dropdown);
        var value = $dropdown.val();
        $dropdown.val("");
        var firstOption = $dropdown.find("option")[0];
        $dropdown.html("");
        $dropdown.append(firstOption);
        $.each(selectList, function (ind, val) {
            $dropdown.append($("<option></option>").val(val.value).text(val.text));
        });
        $dropdown.val(value);
        $dropdown.trigger("change");
    };
    return betEditHandler;
}());
var betEditHandlerArgs = (function () {
    function betEditHandlerArgs() {
    }
    return betEditHandlerArgs;
}());
var payoutHandler = (function () {
    function payoutHandler(container, prefix, sign) {
        this.uiElements = {
            container: null,
            reasonContainer: null,
            hint: null,
            typeSelector: null,
            reason: null
        };
        this.adjustmentType = "Adjustment";
        this.paymentType = "Payment";
        this.payoutType = "Payout";
        this.prefix = "Bookmaker";
        this.sign = "₹";
        this.uiElements.container = $(container);
        this.uiElements.reasonContainer = $(".reason-container", this.uiElements.container);
        this.uiElements.hint = $(".hint", this.uiElements.container);
        this.uiElements.typeSelector = $("#PaymentType", this.uiElements.container);
        this.uiElements.reason = $("#Type", this.uiElements.container);
        this.sign = sign != null && sign != "" ? sign : this.sign;
        if (prefix && prefix != '') {
            this.prefix = prefix;
        }
        this.subscribeToEvents();
    }
    payoutHandler.prototype.subscribeToEvents = function () {
        var _this = this;
        this.uiElements.typeSelector.change(function (e) {
            var paymentTypeVal = _this.uiElements.typeSelector.val();
            var isAdjustment = paymentTypeVal == _this.adjustmentType;
            if (isAdjustment) {
                _this.uiElements.reason.val("");
                _this.uiElements.reasonContainer.toggle(true);
            }
            else {
                _this.uiElements.reason.val(paymentTypeVal);
                _this.uiElements.reasonContainer.toggle(false);
            }
            _this.uiElements.hint.text(_this.createHint());
        });
        this.uiElements.container.on("change keyup", "#Payment", function (e) {
            _this.uiElements.hint.text(_this.createHint());
        });
        this.uiElements.container.on("change keyup", "#Type", function (e) {
            var val = _this.uiElements.reason.val();
            _this.uiElements.reason.next("span").toggle(true).text(118 - val.toString().length + " characters left.");
        });
    };
    payoutHandler.prototype.createHint = function () {
        var type = this.uiElements.typeSelector.val();
        switch (type) {
            case this.paymentType:
                {
                    var str = this.prefix + " will be debited " + this.sign + $("#Payment", this.uiElements.container).val();
                    return str;
                }
            case this.payoutType:
                {
                    var str = this.prefix + " will be credited " + this.sign + $("#Payment", this.uiElements.container).val();
                    return str;
                }
            default: {
                var sign = parseFloat($("#Payment", this.uiElements.container).val()) > 0;
                if (sign) {
                    var str = this.prefix + " will be debited " + this.sign + $("#Payment", this.uiElements.container).val();
                    return str;
                }
                else {
                    var str = this.prefix + " will be credited " + this.sign + $("#Payment", this.uiElements.container).val();
                    return str;
                }
            }
        }
    };
    return payoutHandler;
}());
var playerBalanceAgentHandler = (function () {
    function playerBalanceAgentHandler(args) {
        this.uiElements = {
            mainContainer: null,
            listContainer: null,
            listInnerPagingSorting: null
        };
        this._args = args;
        this.uiElements.mainContainer = $(args.container);
        this.uiElements.listContainer = $(".paging-sorting-update", this.uiElements.mainContainer);
        this.uiElements.listInnerPagingSorting = new appPagingSorting(args.container, args.getUrl, ".paging-sorting-filter-form");
        this.subscribeToEvents();
        this.startConnection();
    }
    playerBalanceAgentHandler.prototype.startConnection = function () {
        var _this = this;
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl("/playerbethub")
            .build();
        this.connection.start().catch(function (err) { return console.log(err); });
        var refreshAction = function () {
            _this.refreshBalances();
        };
        this.connection.on("HorsesExcluded", function (raceId) {
            refreshAction();
        });
        this.connection.on("RefreshRaceResults", function () {
            refreshAction();
        });
    };
    playerBalanceAgentHandler.prototype.subscribeToEvents = function () {
        var self = this;
        self.uiElements.mainContainer.on("click", "#resetBtn", function (e) {
            e.preventDefault();
            self.update();
        });
        self.uiElements.mainContainer.on("click", "#exportBtn", function (e) {
            e.preventDefault();
            var $form = $("form", self.uiElements.mainContainer);
            var $newForm = $('<form>', {
                'action': self._args.exportUrl,
                'method': "POST"
            });
            var array = $form.serializeArray();
            for (var _i = 0, array_2 = array; _i < array_2.length; _i++) {
                var pair = array_2[_i];
                $newForm.append($('<input>', {
                    'name': pair.name,
                    'value': pair.value,
                    'type': 'hidden'
                }));
            }
            ;
            $newForm.appendTo("body").submit().remove();
        });
        self.uiElements.mainContainer.on("change", "#AgentId", function () {
            self.update();
        });
    };
    playerBalanceAgentHandler.prototype.update = function () {
        var self = this;
        var agentId = $("#AgentId", this.uiElements.mainContainer).val();
        this.uiElements.listInnerPagingSorting.sendRequest({ AgentId: agentId }, false);
    };
    playerBalanceAgentHandler.prototype.refreshBalances = function () {
        var self = this;
        var search = $("#Search", this.uiElements.mainContainer).val();
        var agentId = $("#AgentId", this.uiElements.mainContainer).val();
        var pagingSorting = this.uiElements.listInnerPagingSorting.getState();
        $.post(self._args.getJsonBalancesUrl, { Search: search, AgentId: agentId, PagingSortingInfo: pagingSorting }, function (data) {
            $.each(data.items, function (ind, v) {
                self.refreshBalance(v);
            });
        });
    };
    playerBalanceAgentHandler.prototype.refreshBalance = function (v) {
        var self = this;
        var $tr = this.uiElements.listContainer.find("[data-player-id='" + v.id + "']");
        if ($tr.length > 0) {
            var $balanceTd = $tr.find("[data-balance-td]");
            var oldBalance = $tr.find("[data-balance-td]").attr("data-balance-td");
            if (oldBalance && oldBalance != '') {
                var oldBalanceNum = parseFloat(oldBalance);
                var priceChangeType = self.getPriceChange(oldBalanceNum, v.balance);
                if (priceChangeType == priceChange.PriceGoDown) {
                    $balanceTd.removeClass("standart-text-green");
                    $balanceTd.addClass("standart-text-red");
                }
                if (priceChangeType == priceChange.PriceGoUp) {
                    $balanceTd.removeClass("standart-text-red");
                    $balanceTd.addClass("standart-text-green");
                }
                var balanceString = self.resolveMinus(v.balance);
                $balanceTd.text(balanceString);
            }
        }
    };
    playerBalanceAgentHandler.prototype.resolveMinus = function (balance) {
        if (!balance)
            return "";
        if (balance < 0) {
            var abs = balance * -1;
            var out = "(" + abs + ")";
            return out;
        }
        return balance.toFixed(2);
    };
    playerBalanceAgentHandler.prototype.getPriceChange = function (oldBalance, newBalance) {
        var result = priceChange.NotChanged;
        if (oldBalance > newBalance)
            return priceChange.PriceGoDown;
        if (newBalance > oldBalance)
            return priceChange.PriceGoUp;
        return result;
    };
    return playerBalanceAgentHandler;
}());
var playerBalanceAgentArgs = (function () {
    function playerBalanceAgentArgs() {
    }
    return playerBalanceAgentArgs;
}());
var playerListModel = (function () {
    function playerListModel() {
    }
    return playerListModel;
}());
var playerListItemModel = (function () {
    function playerListItemModel() {
    }
    return playerListItemModel;
}());
var playerBalancesArgs = (function () {
    function playerBalancesArgs() {
    }
    return playerBalancesArgs;
}());
var playerBalanceHandler = (function () {
    function playerBalanceHandler(container, getUrl, playerId, payoutLink, updateStatusUrl, exportUrl, playerBetUrl) {
        var _this = this;
        this.uiElements = {
            container: null,
            bookmakerSelect: null,
            betLocationSelect: null,
            startDate: null,
            endDate: null,
            resetBtn: null,
            okBtn: null,
            dateType: null,
            dateFilterContainer: null,
            listInnerPagingSorting: null,
            formElement: null,
            exportBtn: null
        };
        this.uiElements.container = $(container);
        this.uiElements.listInnerPagingSorting = new appPagingSorting(container, getUrl, null);
        this.exportUrl = exportUrl;
        this.uiElements.dateType = $("#BalanceDateType", this.uiElements.container);
        this.uiElements.bookmakerSelect = $("#BookmakerId", this.uiElements.container);
        this.uiElements.betLocationSelect = $("#BetLocationId", this.uiElements.container);
        this.uiElements.startDate = $("#StartDate", this.uiElements.container);
        this.uiElements.okBtn = $("#okBtn", this.uiElements.container);
        this.uiElements.endDate = $("#EndDate", this.uiElements.container);
        this.uiElements.dateFilterContainer = $(".filters", this.uiElements.container);
        this.uiElements.resetBtn = $("#resetBtn", this.uiElements.container);
        this.uiElements.exportBtn = $("#exportBtn", this.uiElements.container);
        this.uiElements.formElement = $("form", this.uiElements.container);
        this.payoutUrl = payoutLink;
        this.playerId = playerId;
        this.playerBetUrl = playerBetUrl;
        this.updateStatusUrl = updateStatusUrl;
        this.uiElements.okBtn.prop("disabled", true);
        var onSelectFunction = function (dateText, obj) {
            var $el = $(obj.input);
            $($el.attr("data-id")).val(dateText);
            _this.uiElements.okBtn.prop("disabled", false);
        };
        $(".datepicker").datepicker({ dateFormat: "mm/dd/yy", onSelect: onSelectFunction });
        this.subscribeToEvents();
        this.startConnection();
    }
    playerBalanceHandler.prototype.subscribeToEvents = function () {
        var _this = this;
        $('body').addClass('balance');
        this.uiElements.container.on("click", ".payout", function (e) {
            e.preventDefault();
            var dialogOptions = {
                fetchParams: { playerId: _this.playerId },
                saveBtnText: "Apply",
                title: "Log Payment/Payout"
            };
            appSaveFormDialog(_this.payoutUrl, dialogOptions).done(function () { return _this.update({ StartDate: _this.uiElements.startDate.val(), EndDate: _this.uiElements.endDate.val(), BalanceDateType: _this.uiElements.dateType.val() }); });
        });
        this.uiElements.container.on("click", ".player-bet-item", function (e) {
            e.preventDefault();
            var $target = $(e.target).closest("a");
            var id = $target.attr("data-player-bet-id");
            var dialogOptions = {
                fetchParams: { userId: _this.playerId, id: id },
                saveBtnText: "Save",
                title: "Save Player Bet"
            };
            appSaveFormDialog(_this.playerBetUrl, dialogOptions).done(function () { return _this.update({ StartDate: _this.uiElements.startDate.val(), EndDate: _this.uiElements.endDate.val(), BalanceDateType: _this.uiElements.dateType.val() }); });
        });
        if (this.uiElements.exportBtn) {
            this.uiElements.exportBtn.click(function (e) {
                e.preventDefault();
                var $form = _this.uiElements.formElement;
                var $newForm = jQuery('<form>', {
                    'action': _this.exportUrl,
                    'method': "POST"
                });
                var array = $form.serializeArray();
                for (var _i = 0, array_3 = array; _i < array_3.length; _i++) {
                    var pair = array_3[_i];
                    $newForm.append($('<input>', {
                        'name': pair.name,
                        'value': pair.value,
                        'type': 'hidden'
                    }));
                }
                ;
                $newForm.appendTo("body").submit().remove();
            });
        }
        this.uiElements.bookmakerSelect.change(function (e) {
            var value = _this.uiElements.bookmakerSelect.val();
            _this.update({ BookmakerId: value });
        });
        this.uiElements.betLocationSelect.change(function (e) {
            var value = _this.uiElements.betLocationSelect.val();
            _this.update({ BetLocationId: value });
        });
        this.uiElements.okBtn.click(function (e) {
            e.preventDefault();
            _this.uiElements.listInnerPagingSorting.sendRequest({
                StartDate: _this.uiElements.startDate.val(),
                EndDate: _this.uiElements.endDate.val(),
                BalanceDateType: _this.uiElements.dateType.val()
            }, false);
        });
        this.uiElements.resetBtn.click(function (e) {
            e.preventDefault();
            _this.uiElements.startDate.val(null);
            _this.uiElements.endDate.val(null);
            _this.uiElements.dateType.val("Today");
            _this.uiElements.dateType.trigger("change");
            _this.uiElements.betLocationSelect.val(null);
            _this.uiElements.bookmakerSelect.val(null);
            _this.uiElements.dateFilterContainer.find("[data-id='#StartDate']").val('');
            _this.uiElements.dateFilterContainer.find("[data-id='#EndDate']").val('');
            _this.update({ StartDate: '', EndDate: '', BalanceDateType: _this.uiElements.dateType.val(), BookmakerId: _this.uiElements.bookmakerSelect.val(), BetLocationId: _this.uiElements.betLocationSelect.val() });
        });
        this.uiElements.dateType.change(function (e) {
            var val = _this.uiElements.dateType.val();
            if (val == "Custom") {
                _this.uiElements.dateFilterContainer.addClass('d-flex');
            }
            else {
                _this.uiElements.dateFilterContainer.removeClass('d-flex');
                _this.uiElements.container.find(".datepicker").each(function (index, el) {
                    $(el).val('');
                });
                _this.update({ StartDate: '', EndDate: '', BalanceDateType: _this.uiElements.dateType.val() });
            }
        });
    };
    playerBalanceHandler.prototype.startConnection = function () {
        var self = this;
        self.raceResultsConnection = new signalR.HubConnectionBuilder()
            .withUrl("/playerbethub")
            .build();
        self.raceResultsConnection.start().catch(function (err) { return console.log(err); });
        var refreshStatusAction = function () {
            self.update({});
        };
        this.raceResultsConnection.on("RefreshRaceResults", function (raceId) {
            refreshStatusAction();
        });
        this.raceResultsConnection.on("UpdateStatus", function (raceId) {
            refreshStatusAction();
        });
        this.raceResultsConnection.on("HorsesExcluded", function (raceId) {
            refreshStatusAction();
        });
    };
    playerBalanceHandler.prototype.update = function (data) {
        var _this = this;
        this.uiElements.listInnerPagingSorting.sendRequest(data, false);
        if (this.updateStatusUrl) {
            $.get(this.updateStatusUrl, { playerId: this.playerId }, function (data) {
                $(".standart-player-info-container", _this.uiElements.container).html(data);
            });
        }
    };
    return playerBalanceHandler;
}());
var raceResultsHandler = (function () {
    function raceResultsHandler(container, callbackOnClose, getUrl) {
        this.uiElements = {
            container: null,
            onCloseCallback: null,
            getUrl: null
        };
        this.uiElements.container = $(container);
        this.uiElements.onCloseCallback = callbackOnClose;
        this.uiElements.getUrl = getUrl;
        this.subscribeToEvents();
    }
    raceResultsHandler.prototype.subscribeToEvents = function () {
        var _this = this;
        this.uiElements.container.on("click", "[data-race-id]", function (e) {
            $('.warning-toggle', _this.uiElements.container).each(function () {
                $(this).popover('hide');
            });
            var raceId = $(e.target).closest("a").attr("data-race-id");
            var dialogOptions = {
                fetchParams: { raceId: raceId },
                title: "Define Race Results",
                onUrlLoaded: function (container) {
                    var btn = $(".btn-primary", container);
                    var isDefinedResults = $("#ReadOnly", container).val().toString().toLowerCase() == "true";
                    if (isDefinedResults) {
                        btn.remove();
                    }
                },
                saveBtnText: "Save"
            };
            appSaveFormDialog(_this.uiElements.getUrl, dialogOptions).done(function () {
                _this.uiElements.onCloseCallback();
            });
        });
    };
    return raceResultsHandler;
}());
var savePlayerBetHandler = (function () {
    function savePlayerBetHandler(args) {
        this.uiElements = {
            container: null,
            horses: null,
            race: null,
            date: null
        };
        this._args = args;
        this.uiElements.container = $(args.container);
        this.uiElements.horses = $("#HorseId", this.uiElements.container);
        this.uiElements.race = $("#RaceId", this.uiElements.container);
        this.uiElements.date = $(".datepicker", this.uiElements.container);
        var self = this;
        var changeDateAction = function (date) {
            self.onDateChanged(date, self);
        };
        this.uiElements.date.datepicker({
            dateFormat: "mm/dd/yy", onSelect: changeDateAction
        });
        this.subscribeOnEvents();
    }
    savePlayerBetHandler.prototype.subscribeOnEvents = function () {
        var self = this;
        self.uiElements.race.change(function () {
            $.get(self._args.getHorsesUrl, { raceId: self.uiElements.race.val() }, function (data) {
                self.updateDropdown(self.uiElements.horses, data);
            });
        });
    };
    savePlayerBetHandler.prototype.onDateChanged = function (dateText, self) {
        $.get(self._args.getRacesUrl, { Date: dateText == "" ? null : dateText }, function (data) {
            self.updateDropdown(self.uiElements.race, data);
        });
    };
    savePlayerBetHandler.prototype.updateDropdown = function (dropdown, selectList) {
        var $dropdown = $(dropdown);
        var value = $dropdown.val();
        $dropdown.val("");
        var firstOption = $dropdown.find("option")[0];
        $dropdown.html("");
        $dropdown.append(firstOption);
        $.each(selectList, function (ind, val) {
            $dropdown.append($("<option></option>").val(val.value).text(val.text));
        });
        $dropdown.val(value);
        $dropdown.trigger("change");
    };
    return savePlayerBetHandler;
}());
var savePlayerBetArgs = (function () {
    function savePlayerBetArgs() {
    }
    return savePlayerBetArgs;
}());
var totalBalanceHandler = (function () {
    function totalBalanceHandler(container, filterUrl, updateListUrl) {
        this.uiElements = {
            container: null
        };
        this.uiElements.container = $(container);
        this.filterUrl = filterUrl;
        this.updateListUrl = updateListUrl;
        this.subscribeToEvents();
    }
    totalBalanceHandler.prototype.subscribeToEvents = function () {
        var _this = this;
        this.uiElements.container.on("click", ".set-filter", function (e) {
            var args = null;
            if (_this.args) {
                args = _this.args;
            }
            else {
                args = { StartDate: new Date().toDateString(), EndDate: null };
            }
            var options = {
                title: "Set Dates",
                saveBtnText: "Ok",
                fetchParams: args
            };
            site.dialogs.saveFormDialog(_this.filterUrl, options).done(function (data) {
                var json = JSON.parse(data);
                _this.args = json;
                _this.updateList(json);
            });
        });
    };
    totalBalanceHandler.prototype.updateList = function (data) {
        var _this = this;
        $.get(this.updateListUrl, data, function (response) {
            _this.uiElements.container.html(response);
        });
    };
    return totalBalanceHandler;
}());
function appAjaxAreaLoading($area, deffered) {
    var fadeDuration = 250;
    if ($area.length <= 0)
        return;
    var divOverlay = $("<div class='loader' data-loading-overlay=''></div>");
    $area.before(divOverlay);
    divOverlay.fadeIn({ duration: fadeDuration });
    deffered.always(function () {
        divOverlay.fadeOut({
            duration: fadeDuration,
            complete: function () { divOverlay.remove(); }
        });
    });
}
var appAjaxSetup = (function () {
    function appAjaxSetup() {
        var _this = this;
        $(document).ajaxComplete(function (event, jqXHR) {
            var isAjaxRedirect = jqXHR.getResponseHeader('AjaxRedirect') === "1";
            if (isAjaxRedirect) {
                _this.ajaxRedirect(jqXHR);
                return;
            }
            site.init();
        });
        $(document).ajaxError(function (event, jqXHR) {
            $.notify({ message: "Unhandled Error: " + jqXHR.responseText }, { type: 'danger', delay: 7000 });
        });
    }
    appAjaxSetup.prototype.ajaxRedirect = function (jqXHR) {
        var redirectUrl = jqXHR.getResponseHeader('location');
        var pathAndQuery = redirectUrl.split('?');
        if (pathAndQuery.length === 2) {
            var queryArgs = pathAndQuery[1].split('&');
            var isUrlChanged = false;
            for (var i = 0; i < queryArgs.length; i++) {
                if (queryArgs[i].indexOf("ReturnUrl=") === 0) {
                    var rootPath = window.location.protocol + "//" + window.location.host + "/";
                    queryArgs[i] = "ReturnUrl=" + encodeURIComponent("/" + window.location.href.replace(rootPath, ""));
                    isUrlChanged = true;
                    break;
                }
            }
            if (isUrlChanged) {
                pathAndQuery[1] = queryArgs.join('&');
                redirectUrl = pathAndQuery.join('?');
            }
        }
        window.location.href = redirectUrl;
    };
    return appAjaxSetup;
}());
var appFilterControl = (function () {
    function appFilterControl(container) {
        this.events = $(this);
        this.uiElements = {
            container: null,
            form: null,
            btnApply: null,
            btnClear: null
        };
        this.on = $.proxy(this.events.on, this.events);
        this.off = $.proxy(this.events.off, this.events);
        this.uiElements.container = container;
        this.initUi();
        this.subscribeToEvents();
        this.refreshHighlights();
    }
    appFilterControl.prototype.getFilteredColumns = function () {
        var columns = [];
        this.getNonEmptyFilterControls()
            .each(function (index, elem) {
            var column = $(elem).attr("data-highlight-column") || $(elem).attr("name");
            if (column) {
                var splitted = column.split(",");
                for (var i = 0; i < splitted.length; i++) {
                    columns.push(splitted[i]);
                }
            }
        });
        return columns;
    };
    appFilterControl.prototype.subscribeToEvents = function () {
        var _this = this;
        this.getFilterControls().change(function () { _this.updateClearButtonStatus(); });
        $(":input[autocomplete]", this.uiElements.container).keyup(function () { _this.updateClearButtonStatus(); });
        this.uiElements.btnApply.click(function (e) {
            e.preventDefault();
            _this.submitFilter();
        });
        this.uiElements.form.submit(function (e) {
            e.preventDefault();
            _this.submitFilter();
        });
        this.uiElements.btnClear.click(function (e) {
            e.preventDefault();
            if (_this.uiElements.btnClear.attr("disabled") === "disabled")
                return;
            _this.getFilterControls().val(null);
            _this.updateClearButtonStatus();
            _this.submitFilter();
        });
    };
    appFilterControl.prototype.submitFilter = function () {
        var args = { filterData: this.uiElements.form.serialize(), filteredColumns: this.getFilteredColumns() };
        this.events.trigger("filter-control-changed", args);
        this.refreshHighlights();
    };
    appFilterControl.prototype.updateClearButtonStatus = function () {
        var isNonEmpty = this.getNonEmptyFilterControls().length > 0;
        this.uiElements.btnClear.prop("disabled", !isNonEmpty);
    };
    appFilterControl.prototype.refreshHighlights = function () {
        var _this = this;
        this.updateClearButtonStatus();
        this.getFilterControls().each(function (i, el) { return _this.highlightFilterElement($(el)); });
    };
    appFilterControl.prototype.highlightFilterElement = function ($element) {
        $element.toggleClass("highlight", this.isNonEmptyFilterControl($element));
    };
    appFilterControl.prototype.getFilterControls = function () {
        return $(":input", this.uiElements.container);
    };
    appFilterControl.prototype.getNonEmptyFilterControls = function () {
        var _this = this;
        return this.getFilterControls()
            .filter(function (i, elem) { return _this.isNonEmptyFilterControl(elem); });
    };
    appFilterControl.prototype.isNonEmptyFilterControl = function (elem) {
        return $(elem).val() !== "";
    };
    appFilterControl.prototype.initUi = function () {
        this.uiElements.btnApply = $("[data-apply]", this.uiElements.container);
        this.uiElements.btnClear = $("[data-clear]", this.uiElements.container);
        this.uiElements.form = this.uiElements.container;
    };
    return appFilterControl;
}());
var appPagingSorting = (function () {
    function appPagingSorting(containerSelector, url, filterFormSelector) {
        var _this = this;
        this.uiElements = {
            container: null,
            getTable: null,
            getState: null
        };
        this.filter = null;
        this.containerSelector = containerSelector;
        this.url = url;
        this.filterFormSelector = filterFormSelector;
        this.uiElements.container = $(".paging-sorting-update", $(containerSelector));
        if (this.uiElements.container.length === 0) {
            var errMsg = ".paging-sorting-update not found in container '" + containerSelector + "' or container not found";
            alert(errMsg);
            throw new Error(errMsg);
        }
        this.uiElements.getTable = function () { return $("table.paging-sorting", _this.uiElements.container); };
        this.uiElements.getState = function () { return $("[data-paging-sorting-state]", _this.uiElements.container); };
        this.initFilterControl();
        this.subscribeToEvents();
    }
    appPagingSorting.prototype.initFilterControl = function () {
        var filterContainer;
        if (this.filterFormSelector) {
            filterContainer = $(this.filterFormSelector);
        }
        else {
            filterContainer = $(".paging-sorting-filter-form", $(this.containerSelector));
        }
        if (filterContainer.length > 0) {
            this.filter = new appFilterControl(filterContainer);
            this.refreshHighlights();
        }
    };
    appPagingSorting.prototype.refreshHighlights = function () {
        if (this.filter) {
            this.highlightTableColumns(this.filter.getFilteredColumns());
        }
    };
    appPagingSorting.prototype.highlightTableColumns = function (columns) {
        $("[data-sortmember]", this.uiElements.container).each(function (index, elem) {
            var $this = $(elem);
            var currentColumn = $this.attr("data-sortmember");
            $this.toggleClass("highlight", columns.indexOf(currentColumn) >= 0);
        });
    };
    appPagingSorting.prototype.sendRequest = function (data, keepPaging) {
        var parametesData = this.getState();
        data = appSerializeObject(data);
        if (data) {
            $.extend(parametesData, data);
        }
        if (!keepPaging) {
            $.extend(parametesData.PagingSortingInfo, { Page: 1 });
        }
        return this.ajaxRequest(parametesData);
    };
    appPagingSorting.prototype.subscribeToEvents = function () {
        var _this = this;
        this.subscribeToPaging();
        this.subscribeToSorting();
        if (this.filter) {
            this.filter.on("filter-control-changed", function (e, args) {
                var data = _this.deparam(args.filterData);
                var parametesData = _this.getState();
                $.extend(parametesData, data);
                _this.ajaxRequest(parametesData);
            });
        }
    };
    appPagingSorting.prototype.deparam = function (query) {
        if (!query)
            return {};
        var pairs, i, keyValuePair, key, value;
        var map = {};
        if (query.slice(0, 1) === '?') {
            query = query.slice(1);
        }
        if (query !== '') {
            pairs = query.split('&');
            for (i = 0; i < pairs.length; i += 1) {
                keyValuePair = pairs[i].split('=');
                key = decodeURIComponent(keyValuePair[0]);
                value = (keyValuePair.length > 1) ? decodeURIComponent(keyValuePair[1]) : undefined;
                map[key] = value;
            }
        }
        return map;
    };
    appPagingSorting.prototype.subscribeToPaging = function () {
        var _this = this;
        this.uiElements.container.on("click", "a[data-Page]", function (event) {
            var $this = $(event.currentTarget);
            var page = $this.attr("data-Page");
            var data = { Page: page };
            _this.uiElements.container.find("a[data-Page]").each(function (index, $val) {
                var p = $($val).attr("data-Page");
                if (p == page) {
                    $($val).closest("page-item").addClass("disabled");
                }
                else {
                    $($val).closest("page-item").removeClass("disabled");
                }
            });
            _this.pagingSortingChanged(data);
        });
    };
    appPagingSorting.prototype.subscribeToSorting = function () {
        var _this = this;
        this.uiElements.container.on("click", ".paging-sorting th[data-SortMember]", function (event) {
            var $this = $(event.currentTarget);
            var sortMember = $this.attr("data-SortMember");
            var sortDescending = $this.attr("data-SortDescending");
            var data = {
                SortMember: sortMember,
                SortDescending: sortDescending
            };
            _this.pagingSortingChanged(data);
        });
    };
    appPagingSorting.prototype.pagingSortingChanged = function (changedData) {
        var parametesData = this.getState();
        var pagingSortingInfoData = parametesData["PagingSortingInfo"];
        $.extend(pagingSortingInfoData, changedData);
        parametesData["PagingSortingInfo"] = pagingSortingInfoData;
        this.ajaxRequest(parametesData);
    };
    appPagingSorting.prototype.getState = function () {
        var stateControl = this.uiElements.getState();
        if (stateControl.length <= 0)
            return null;
        return JSON.parse(stateControl.attr("data-paging-sorting-state"));
    };
    appPagingSorting.prototype.ajaxRequest = function (data) {
        var _this = this;
        var $self = this;
        var deff = $.ajax({
            url: this.url,
            data: data,
            cache: false,
            type: "POST",
        })
            .done(function (html) {
            _this.uiElements.container.empty().append(html);
        })
            .always(function () {
            $($self).trigger("request-complete");
            _this.refreshHighlights();
        });
        appAjaxAreaLoading(this.uiElements.getTable().find("tbody"), deff);
        return deff.promise();
    };
    return appPagingSorting;
}());
function appSerializeObject(object, forseNotValidate) {
    if (forseNotValidate === void 0) { forseNotValidate = false; }
    if ($.isPlainObject(object)) {
        return object;
    }
    var serializeArray;
    if ($.isArray(object)) {
        serializeArray = object;
    }
    else {
        var inputs = $(object).find(":input");
        serializeArray = inputs.serializeArray();
        inputs.filter("select.multiselect").each(function () {
            if (!$(this).val() || !$(this).val().toString().length) {
                var name_1 = $(this).attr("id");
                var nameExistInArray = false;
                for (var i = 0; i < serializeArray.length; i++) {
                    if (serializeArray[i].name === name_1) {
                        nameExistInArray = true;
                        break;
                    }
                }
                if (!nameExistInArray) {
                    serializeArray.push({
                        name: name_1,
                        value: "<CREATE_EMPTY_ARRAY>"
                    });
                }
            }
        });
    }
    var self = this, json = {}, pushCounters = {}, patterns = {
        "validate": /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
        "key": /[a-zA-Z0-9_]+|(?=\[\])/g,
        "push": /^$/,
        "fixed": /^\d+$/,
        "named": /^[a-zA-Z0-9_]+$/
    };
    this.build = function (base, key, value) {
        base[key] = value;
        return base;
    };
    this.push_counter = function (key) {
        if (pushCounters[key] === undefined) {
            pushCounters[key] = 0;
        }
        return pushCounters[key]++;
    };
    $.each(serializeArray, function () {
        if (!forseNotValidate) {
            if (!patterns.validate.test(this.name)) {
                return;
            }
        }
        var k, keys = this.name.match(patterns.key), merge = this.value, reverse_key = this.name;
        while ((k = keys.pop()) !== undefined) {
            reverse_key = reverse_key.replace(new RegExp("\\[" + k + "\\]$"), '');
            if (k.match(patterns.push)) {
                merge = self.build([], self.push_counter(reverse_key), merge);
            }
            else if (k.match(patterns.fixed)) {
                merge = self.build([], k, merge);
            }
            else if (k.match(patterns.named)) {
                merge = self.build({}, k, merge);
            }
        }
        if (this.value === "<CREATE_EMPTY_ARRAY>") {
            json[this.name] = [];
        }
        else {
            if ((this.name in json)) {
                if (!(Object.prototype.toString.call(json[this.name]) === '[object Array]')) {
                    json[this.name] = [json[this.name]];
                }
                json[this.name].push(this.value);
            }
            else {
                json = $.extend(true, json, merge);
            }
        }
    });
    return json;
}
function appShowScriptMessages() {
    var scriptMessagesBase64 = $.cookie("SiteScriptMessage");
    if (scriptMessagesBase64) {
        $.cookie("SiteScriptMessage", null, { path: "/", expires: -1 });
    }
    if (scriptMessagesBase64 && scriptMessagesBase64 != "") {
        var scriptMessagesJson = Base64.decode(scriptMessagesBase64);
        showScriptMessages(scriptMessagesJson);
    }
    function showScriptMessages(jsonString) {
        var json = $.parseJSON(jsonString);
        if (json) {
            var scriptItems = [];
            if (json.length) {
                scriptItems = json;
            }
            for (var i = 0; i < scriptItems.length; i++) {
                var message = scriptItems[i];
                evaluateScriptMessage(message.Message, message.MessageDataType, message.MessageTypeString);
            }
        }
    }
    function evaluateScriptMessage(message, dataType, dataMessageType) {
        if (dataType === 'messsage') {
            var delay = 2000;
            if (dataMessageType === 'danger')
                delay = 7000;
            $.notify({ message: message }, { type: dataMessageType, delay: delay });
        }
        else if (dataType === 'script') {
            eval(message);
        }
        else {
            throw new Error("Unknown message dataType - " + dataType);
        }
    }
}
var appUtils = (function () {
    function appUtils() {
    }
    appUtils.prototype.htmlEncode = function (value) {
        return $('<div/>').text(value).html();
    };
    appUtils.prototype.htmlToText = function (value) {
        return $('<div/>').html(value).text();
    };
    appUtils.prototype.readCookieRaw = function (name) {
        var raw = $.cookie.raw;
        try {
            $.cookie.raw = true;
            var result = $.cookie(name);
            $.cookie.raw = raw;
            return result;
        }
        catch (e) {
            $.cookie.raw = raw;
            throw e;
        }
    };
    appUtils.prototype.autofocus = function () {
        var $focus = $("[data-focus]").not("[data-focus-placed='true']");
        if ($focus.length > 0) {
            $focus.attr("data-focus-placed", "true");
            this.focusOnElement($focus);
        }
    };
    appUtils.prototype.focusOnElement = function ($focus) {
        var doc = document;
        var elem = $focus[0];
        var elemLen = elem.value.length;
        if (doc.selection) {
            elem.focus();
            var oSel = doc.selection.createRange();
            oSel.moveStart('character', -elemLen);
            oSel.moveStart('character', elemLen);
            oSel.moveEnd('character', 0);
            oSel.select();
        }
        else if (elem.selectionStart || elem.selectionStart == '0') {
            elem.selectionStart = elemLen;
            elem.selectionEnd = elemLen;
            elem.focus();
        }
    };
    return appUtils;
}());
var appValidators = (function () {
    function appValidators() {
        var defaultOptions = {
            ignore: ":hidden:not([data-validatehidden])"
        };
        $.validator.setDefaults(defaultOptions);
    }
    appValidators.prototype.refreshValidators = function (containerSelector) {
        var $forms = $(containerSelector);
        if (!$forms.is("form")) {
            $forms = $forms.find("form");
        }
        $forms.validateBootstrap(true);
    };
    return appValidators;
}());
var appDialogs = (function () {
    function appDialogs() {
        this.saveFormDialog = appSaveFormDialog;
        this.alert = appAlertDialog;
        this.confirm = appConfirmDialog;
    }
    return appDialogs;
}());
var appSite = (function () {
    function appSite() {
        _.templateSettings.variable = "model";
        this.appAjaxSetup = new appAjaxSetup();
        this.validators = new appValidators();
        this.dialogs = new appDialogs();
        this.utils = new appUtils();
        $(document).ready(function () {
            site.init();
        });
    }
    appSite.prototype.init = function () {
        appShowScriptMessages();
        new appControlAutocomplete().init();
        this.utils.autofocus();
    };
    return appSite;
}());
var site = new appSite();
var listHandler = (function () {
    function listHandler(args) {
        this.uiElements = {
            container: null,
            listContainer: null,
            listInnerPagingSorting: null
        };
        this._args = args;
        this.uiElements.container = $(args.container);
        this.uiElements.listContainer = $(".paging-sorting-update", this.uiElements.container);
        this.uiElements.listInnerPagingSorting = new appPagingSorting(args.container, args.getUrl, ".paging-sorting-filter-form");
        this.subscribeToEvents();
    }
    listHandler.prototype.subscribeToEvents = function () {
        var _this = this;
        this.uiElements.container.on("click", "[data-delete-id]", function (e) {
            e.preventDefault();
            var $self = _this;
            var $target = $(e.target).closest("a");
            var id = $target.attr("data-delete-id");
            var opts = new appConfirmDialogOptions();
            site.dialogs.confirm("Are you sure?", function (isConfirmed) {
                if (!isConfirmed)
                    return;
                $.post($self._args.deleteUrl, { id: id }, function () {
                    $self.uiElements.listInnerPagingSorting.sendRequest({}, false);
                });
            }, opts);
        });
        this.uiElements.container.on("click", "[data-edit-id]", function (e) {
            var $self = _this;
            var opts = new appSaveFormDialogOptions();
            var id = $(e.target).closest("a").attr("data-edit-id");
            if (id && id != '') {
                opts.title = "Edit " + $self._args.dialogTitle;
            }
            else {
                opts.title = "Create " + $self._args.dialogTitle;
            }
            opts.fetchParams = { id: id };
            site.dialogs.saveFormDialog($self._args.editUrl, opts).done(function () {
                $self.uiElements.listInnerPagingSorting.sendRequest({}, false);
            });
        });
    };
    return listHandler;
}());
var listHandlerArgs = (function () {
    function listHandlerArgs() {
    }
    return listHandlerArgs;
}());
var appControlAutocomplete = (function () {
    function appControlAutocomplete() {
    }
    appControlAutocomplete.prototype.init = function () {
        $("input[data-autocomplete-url]:not(.processed)").each(function (index, elem) {
            var $this = $(elem);
            $this.addClass("processed");
            $this.autocomplete({
                source: function (request, response) {
                    $.ajax({
                        type: "POST",
                        url: $this.attr("data-autocomplete-url"),
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        data: JSON.stringify({ prefixText: request.term, count: ($this.attr("data-itemscount") || '20'), contextKey: ($this.attr("data-contextKey") || "") }),
                        success: function (data) {
                            response($.map(data, function (item) { return ({
                                label: item.label,
                                value: item.value,
                                data: item.data
                            }); }));
                        }
                    });
                },
                minLength: 0,
                delay: 100,
                select: function (event, ui) {
                    if (ui.item.value === '[No matches found]')
                        ui.item.value = '';
                },
                open: function () {
                    $this.removeClass("ui-corner-all").addClass("ui-corner-top").addClass("autocompleteOpen");
                },
                close: function (event, ui) {
                    $this.removeClass("ui-corner-top").addClass("ui-corner-all").removeClass("autocompleteOpen");
                    if ($this.attr("data-onautocompleteclose")) {
                        eval($this.attr("data-onautocompleteclose") + "(event, ui)");
                    }
                }
            });
            $this.dblclick(function () {
                $this.autocomplete("search");
            });
        });
    };
    return appControlAutocomplete;
}());
function appAlertDialog(message, onClose, options) {
    var dialog = appDialogShow({
        title: options.title,
        body: message,
        close: onClose,
        dialogClass: options.dialogClass,
        buttons: [
            {
                text: options.okText,
                buttonClass: 'btn-secondary',
                click: function () {
                    dialog.close();
                    if (onClose) {
                        onClose();
                    }
                }
            }
        ]
    });
}
var appAlertDialogOptions = (function () {
    function appAlertDialogOptions() {
        this.dialogClass = "";
        this.title = "";
        this.okText = "OK";
    }
    return appAlertDialogOptions;
}());
function appConfirmDialog(message, onClose, options) {
    var onCloseSafe = function (isConfirmed) {
        if (onClose) {
            onClose(isConfirmed || false);
        }
    };
    var dialog = appDialogShow({
        title: options.title,
        body: message,
        close: onCloseSafe,
        timer: options.timer,
        timerCallback: options.timerCallback,
        dialogClass: options.dialogClass,
        buttons: [
            {
                text: options.cancelText,
                buttonClass: 'btn-secondary bt-cancel',
                click: function () {
                    dialog.close();
                    onCloseSafe(false);
                }
            },
            {
                text: options.okText,
                buttonClass: 'btn-primary',
                click: function () {
                    dialog.close();
                    onCloseSafe(true);
                }
            }
        ]
    });
}
var appConfirmDialogOptions = (function () {
    function appConfirmDialogOptions() {
        this.dialogClass = "";
        this.title = "";
        this.okText = "OK";
        this.cancelText = "Cancel";
        this.timer = null;
        this.timerCallback = null;
    }
    return appConfirmDialogOptions;
}());
function appDialogShow(options) {
    var modalTemplate = _.template('<div class="modal fade">' +
        '<div class="modal-dialog <%=model.dialogClass%>">'
        + '<div class="modal-content">'
        + "<% if(model.title) { %>"
        + '<div class="modal-header <%=model.headerClass%>">'
        + '<h5 class="modal-title"><%= model.title %></h5>'
        + '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>'
        + '</div>'
        + "<% } %>"
        + '<div class="modal-body"><%= model.body %></div>'
        + '<% if(model.buttons && model.buttons.length > 0) { %>'
        + '<div class="modal-footer">'
        + '<% for(var i = 0; i < model.buttons.length; i++) {%>'
        + '<input type="button" data-sitedialog-button-id="<%= model.buttons[i].buttonId %>" class="btn <%= model.buttons[i].buttonClass %>" value="<%=model.buttons[i].text%>"/>'
        + '<% } %>'
        + '</div>'
        + '<% } %>'
        + '</div>'
        + '</div>'
        + '</div>');
    options = $.extend({
        dialogClass: '',
        title: '',
        body: '',
        close: null,
        headerClass: '',
        buttons: [],
        timer: null,
        timerCallback: null
    }, options);
    if (options.buttons) {
        for (var i = 0; i < options.buttons.length; i++) {
            options.buttons[i].buttonId = ("button_" + Math.random()).replace(".", "");
        }
    }
    var htmlText = modalTemplate(options);
    var $dialog = $(htmlText);
    var skipClose = false;
    if (options.timer) {
        var counter = options.timer;
        var originalText_1 = $dialog.find(".bt-cancel").attr("value");
        $dialog.find(".bt-cancel").attr("value", originalText_1 + " (" + counter + ")");
        var interval = setInterval(function () {
            counter--;
            $dialog.find(".bt-cancel").attr("value", originalText_1 + " (" + counter + ")");
            if (counter == 0) {
                if (options.timerCallback) {
                    options.timerCallback();
                }
                $dialog.modal("hide");
                clearInterval(interval);
            }
        }, 1000);
    }
    $dialog.modal('show');
    if (options.buttons) {
        for (var i = 0; i < options.buttons.length; i++) {
            if (options.buttons[i].click) {
                $("input[data-sitedialog-button-id='" + options.buttons[i].buttonId + "']", $dialog).click(options.buttons[i].click);
            }
        }
    }
    $dialog.on('hidden.bs.modal', function () {
        $dialog.remove();
        if (options.close && !skipClose) {
            options.close();
        }
    });
    return {
        container: $dialog,
        close: function () {
            skipClose = true;
            $dialog.modal("hide");
        }
    };
}
var PopupIframeResult = {
    OK: "OK",
    Cancel: "Cancel"
};
var PopupContext = (function () {
    function PopupContext(callContext, onOK, onCancel) {
        this.Result = null;
        this.ReturnInfo = null;
        this._callContext = callContext;
        this._onOK = onOK;
        this._onCancel = onCancel;
    }
    PopupContext.prototype.FireClose = function (sender) {
        var _eventArgs = { ReturnInfo: this.ReturnInfo, CallContext: this._callContext };
        if (this.Result === PopupIframeResult.OK && this._onOK != null)
            this._onOK(sender, _eventArgs);
        else if ((this.Result == null || this.Result === PopupIframeResult.Cancel) && this._onCancel != null)
            this._onCancel(sender, _eventArgs);
    };
    ;
    return PopupContext;
}());
var PopupIframeManager = {
    CurrentModalPopup: null,
    ModalOnLoad: function () {
        var dv = $('#divModalIframe');
        var dvLoading = dv.find('#divModalIframeLoading');
        var dvIfrHolder = dv.find("#divModalIframeHolder");
        dvLoading.hide();
        dvIfrHolder.show();
    },
    ShowModal: function (url, width, height, title, callContext, onOK, onCancel) {
        setTimeout(function () {
            url = url + (url.indexOf('?') > 0 ? "&" : "?") + "rnd=" + Math.random();
            var dv = $("<div id='divModalIframe' style='display:none; overflow:hidden;'><div id='divModalIframeLoading' style='display:none; color:Gray; padding:15px'>Loading...</div><div id='divModalIframeHolder' style='width:100%; height:100%;'></div></div>");
            var dvLoading = dv.find('#divModalIframeLoading');
            var dvIfrHolder = dv.find("#divModalIframeHolder");
            var isIE = navigator.appName === 'Microsoft Internet Explorer';
            var rndID = Math.random();
            var tplIfr;
            if (isIE) {
                tplIfr = '<iframe id="' + rndID + '" width="100%" height="100%" onload="PopupIframeManager.ModalOnLoad();" marginwidth="0" marginheight="0" frameborder="0" scrolling="auto">Your browser does not support iframes</iframe>';
            }
            else {
                tplIfr = '<iframe id="' + rndID + '" width="100%" height="100%" onload="PopupIframeManager.ModalOnLoad();" marginwidth="0" marginheight="0" frameborder="0" scrolling="auto" src="' + url + '">Your browser does not support iframes</iframe>';
            }
            dvIfrHolder.hide();
            dvIfrHolder.html(tplIfr);
            if (isIE) {
                dvIfrHolder.find('iframe')[0].src = url;
            }
            dvLoading.show();
            PopupIframeManager.CurrentModalPopup = new PopupContext(callContext, onOK, onCancel);
            dv.dialog({
                modal: true,
                width: width,
                height: height,
                title: title,
                buttons: null,
                close: function () {
                    dvIfrHolder.html("");
                    dv.remove();
                    if (PopupIframeManager.CurrentModalPopup != null) {
                        PopupIframeManager.CurrentModalPopup.FireClose(null);
                        PopupIframeManager.CurrentModalPopup = null;
                    }
                },
                resizable: false
            });
        }, 0);
    },
    CloseModal: function (returnInfo, isOK) {
        if (PopupIframeManager.CurrentModalPopup != null) {
            PopupIframeManager.CurrentModalPopup.Result = isOK ? PopupIframeResult.OK : PopupIframeResult.Cancel;
            PopupIframeManager.CurrentModalPopup.ReturnInfo = returnInfo;
        }
        $('#divModalIframe').dialog("close");
    }
};
function appSaveFormDialog(fetchUrl, dialogOptions) {
    var defSaveFormDialog = $.Deferred();
    var dialog = appDialogShow({
        title: dialogOptions.title,
        dialogClass: dialogOptions.dialogClass,
        body: dialogOptions.bodyHtml,
        headerClass: dialogOptions.headerClass,
        buttons: [
            {
                text: "Close",
                buttonClass: 'btn-secondary',
                click: function () {
                    dialog.close();
                }
            },
            {
                text: dialogOptions.saveBtnText,
                buttonClass: "btn-primary",
                click: function () {
                    var $button = $(this);
                    $button.prop("disabled", true);
                    var $form = $('form', dialog.container);
                    if (!$form.valid()) {
                        $button.prop("disabled", false);
                        return;
                    }
                    var postUrl = $form.attr('action');
                    var request;
                    if ($form.attr("enctype") === "multipart/form-data") {
                        var formElem = $form[0];
                        var formdata = new FormData(formElem);
                        request = $.ajax({
                            type: "POST",
                            url: postUrl,
                            data: formdata,
                            processData: false,
                            contentType: false,
                        });
                    }
                    else {
                        var params = $form.serialize();
                        request = $.post(postUrl, params);
                    }
                    request.done(function (data, textStatus, xhr) {
                        $button.prop("disabled", false);
                        if (xhr.getResponseHeader('CloseDialog') === "1") {
                            defSaveFormDialog.resolve(xhr.getResponseHeader('CloseDialogResult'));
                            dialog.close();
                            return;
                        }
                        dialog.container.find(".modal-body").html(data);
                        site.validators.refreshValidators(dialog.container);
                    });
                }
            }
        ]
    });
    dialog.container.on("shown.bs.modal", function () {
        $(".btn-primary", dialog.container).prop("disabled", true);
        $.get(fetchUrl, dialogOptions.fetchParams, function (data) {
            dialog.container.find(".modal-body").html(data);
            site.validators.refreshValidators(dialog.container);
            if (dialog.container.find("form").length == 0) {
                $(".btn-primary", dialog.container).prop("disabled", true);
            }
            else {
                $(".btn-primary", dialog.container).prop("disabled", false);
            }
            if (dialogOptions.onUrlLoaded) {
                dialogOptions.onUrlLoaded(dialog.container);
            }
        });
    });
    return defSaveFormDialog.promise();
}
var appSaveFormDialogOptions = (function () {
    function appSaveFormDialogOptions() {
        this.fetchParams = null;
        this.title = "Dialog";
        this.saveBtnText = "Save changes";
        this.bodyHtml = "<p>Loading...</p>";
        this.dialogClass = "";
        this.headerClass = "";
    }
    return appSaveFormDialogOptions;
}());
var betHistoryHandler = (function () {
    function betHistoryHandler(container, userId, updateUrl, adminMode) {
        if (adminMode === void 0) { adminMode = false; }
        this.uiElements = {
            container: null,
            table: null
        };
        this.uiElements.container = $(container);
        this.userId = userId;
        this.uiElements.table = $(".table-container-unfinished-bets", this.uiElements.container);
        this.updateUrl = updateUrl;
        this.adminMode = adminMode;
        this.startConnection();
    }
    betHistoryHandler.prototype.startConnection = function () {
        var _this = this;
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl("/playerbethub?userId=" + this.userId)
            .build();
        this.connection.start().catch(function (err) { return console.log(err); });
        var refreshAction = function (raceId, list) { return _this.refresh(raceId, list); };
        var refreshPageAction = function (raceId) {
            if (_this.isRefreshNeeded(raceId)) {
                var options = new appConfirmDialogOptions();
                appConfirmDialog("Results for race in list was updated. Do you want to refresh page?", function (isConfirmed) {
                    if (isConfirmed) {
                        window.location.reload();
                    }
                }, options);
            }
        };
        this.connection.on("UpdateBets", function (raceId, list) {
            refreshAction(raceId, list);
        });
        this.connection.on("RefreshRaceResults", function (raceId) {
            refreshPageAction(raceId);
        });
        var refreshForced = function (raceId) {
            _this.forcedUpdate();
        };
        this.connection.on("HorsesExcluded", function (raceId) {
            refreshForced(raceId);
        });
    };
    betHistoryHandler.prototype.refresh = function (raceId, list) {
        var _this = this;
        var self = this;
        if (list.length > 0) {
            this.uiElements.container.find(".unfinished-bets-table-container").removeClass("d-none").addClass("d-flex");
            $.each(list, function (ind, val) {
                var $tbody = _this.uiElements.table.find("tbody");
                var name = "";
                if (val.raceNumber != null) {
                    name += val.raceNumber + " - ";
                }
                name += val.trackName;
                var betOddsString = val.numerator != null && val.numerator != 0 && val.denominator != null && val.denominator != 0
                    ? parseFloat(val.numerator.toFixed(2)) + "/" + parseFloat(val.denominator.toFixed(2))
                    : '-';
                var layOddsString = val.layNumerator != null && val.layNumerator != 0 && val.layDenominator != null && val.layDenominator != 0
                    ? parseFloat(val.layNumerator.toFixed(2)) + "/" + parseFloat(val.layDenominator.toFixed(2))
                    : '-';
                var layBetString = val.layBet == null ? "" : val.layBet;
                var betString = val.bet == null ? "" : val.bet;
                var $trAdmin = "<tr data-race-bet-id='" + val.raceId + "'><td>" + new Date(val.updatedDate).toLocaleString().replace(",", "") + "</td><td><a href='javascript:void(0);' class='player-bet-item' data-player-bet-id='" + val.id + "'>" + name + "</a></td><td>" + val.horseName + "</td><td>" + betOddsString + "</td><td>" + betString + "</td><td>" + layOddsString + "</td><td>" + layBetString + "</td></tr>";
                var $trUser = "<tr data-race-bet-id='" + val.raceId + "'><td>" + new Date(val.updatedDate).toLocaleString().replace(",", "") + "</td><td><a href='javascript:void(0);' class='player-bet-item' data-player-bet-id='" + val.id + "'>" + name + "</a></td><td>" + val.horseName + "</td><td>" + betOddsString + "</td><td>" + betString + "</td><td>" + layOddsString + "</td><td>" + layBetString + "</td></tr>";
                var $tr = self.adminMode
                    ? $trAdmin
                    : $trUser;
                var existedTr = $tbody.find("[data-player-bet-id='" + val.id + "']").closest("tr");
                if (existedTr.length > 0) {
                    existedTr.replaceWith($tr);
                }
                else {
                    $tbody.append($tr);
                }
            });
        }
    };
    betHistoryHandler.prototype.forcedUpdate = function () {
        var self = this;
        $.get(self.updateUrl, { UserId: self.userId }, function (data) {
            self.uiElements.container.find(".unfinished-bets-table-container").replaceWith(data);
        });
    };
    betHistoryHandler.prototype.isRefreshNeeded = function (raceId) {
        return this.uiElements.table.find("[data-race-bet-id='" + raceId + "']").length > 0;
    };
    return betHistoryHandler;
}());
var PlayerBetAdminModel = (function () {
    function PlayerBetAdminModel() {
    }
    return PlayerBetAdminModel;
}());
var playerHandler = (function () {
    function playerHandler(args) {
        this.uiElements = {
            container: null,
            statusContainer: null,
            listInnerPagingSorting: null,
            date: null
        };
        this._lock = false;
        this._args = args;
        this.uiElements.container = $(this._args.container);
        this.uiElements.statusContainer = $(".standart-player-info-container", this.uiElements.container);
        this.initUI();
        this.subscribeToEvents();
        this.getRestrictions();
    }
    playerHandler.prototype.initUI = function () {
        this.uiElements.listInnerPagingSorting = new appPagingSorting(this._args.container, this._args.getRacesUrl, ".paging-filter");
        this.uiElements.date = $(".datepicker", this.uiElements.container);
        this.uiElements.date.datepicker({
            dateFormat: "mm/dd/yy", onSelect: this.onSelect, onClose: this.onSelect
        });
        this.startConnection();
    };
    playerHandler.prototype.mobileToggleColumns = function (isColumnToggled) {
        if (!isColumnToggled) {
            $('.race-bets-container').removeClass('d-none');
            $('.standart-page-player').addClass('mobile-screen');
            $('.standart-bet-wrapper-footer').removeClass('d-none');
        }
        else {
            $('.race-bets-container').addClass('d-none');
            $('.standart-page-player').removeClass('mobile-screen');
            $('.standart-bet-wrapper-footer').addClass('d-none');
        }
        $('.mobile-bets-header').toggleClass('d-none d-lg-none');
        $('.race-filter').toggleClass('d-none d-flex d-lg-flex');
        $('.race-cards').toggleClass('d-none d-flex d-lg-flex');
        var self = this;
        self.disableOrEnableSubmit();
    };
    playerHandler.prototype.subscribeToEvents = function () {
        var self = this;
        $(this.uiElements.listInnerPagingSorting).on("request-complete", function () {
            self.onRefreshRaceList();
        });
        this.uiElements.container.on("keyup", "[data-bet], [data-lay-bet]", function (e) {
            self.disableOrEnableSubmit();
            $(e.target).validate();
        });
        this.uiElements.container.on("click", "a[data-race-id]", function (e) {
            e.preventDefault();
            var element = $(e.target).closest("[data-race-id]");
            var raceId = element.attr("data-race-id");
            var title = element.find('.race-name').text();
            $('.mobile-race-name').text(title);
            element.prevAll().removeClass('active');
            element.nextAll().removeClass('active');
            element.addClass('active');
            self.mobileToggleColumns(false);
            $('.raceBets').addClass('loading');
            self.uiElements.container.find(".raceBets").html('');
            $.get(self._args.getBetsUrl, { raceId: raceId }, function (data) {
                $('.raceBets').removeClass('loading');
                self.uiElements.container.find(".raceBets").html(data);
                self.addValidationsForForm();
                self.disableOrEnableSubmit();
            });
        });
        this.uiElements.container.on("click", ".mobile-race-back", function (e) {
            e.preventDefault();
            $('.mobile-race-name').text('');
            self.mobileToggleColumns(true);
            $('a[data-race-id]').removeClass('active');
        });
        $(".raceBets", this.uiElements.container).on("submit", function (e) {
            e.preventDefault();
            var raceId = $("form", self.uiElements.container).find("#RaceId").val();
            var $form = $("form", $(".raceBets"));
            if ($form.valid()) {
                if (self._lock == false) {
                    self._lock = true;
                    var text = self.getBetsAsString();
                    site.dialogs.confirm(text + "Are you sure?", function (isConfirmed) {
                        self._lock = false;
                        if (isConfirmed) {
                            var $form_1 = $("form", $(".raceBets"));
                            if ($form_1.valid()) {
                                $.post($form_1.attr("action"), $form_1.serialize(), function (data) {
                                    if (self.isJson(data)) {
                                        $.get(self._args.getBetsUrl, { raceId: data.raceId }, function (data) {
                                            $(".raceListContainer").find(".raceBets").html(data);
                                            self.disableOrEnableSubmit();
                                            self.getBalances();
                                            self.addValidationsForForm();
                                        });
                                    }
                                    else {
                                        $(".raceListContainer").find(".raceBets").html(data);
                                        site.validators.refreshValidators(self.uiElements.container);
                                        self.disableOrEnableSubmit();
                                        self.addValidationsForForm();
                                        self.getBalances();
                                    }
                                    self.updateStatus();
                                });
                            }
                        }
                    }, {
                        okText: "OK", cancelText: "Cancel", timer: 5, timerCallback: function () {
                            self._lock = false;
                            self.refreshBets(raceId, null, null, null, true);
                        }
                    });
                }
            }
        });
        this.uiElements.container.on('click', '.delete-link', function (e) {
            e.preventDefault();
            new appSaveFormDialogOptions();
            var id = $(this).closest('[data-item-id]').attr('data-item-id');
            var confirmOptions = new appConfirmDialogOptions();
            site.dialogs.confirm("Are you sure?", function (isConfirmed) {
                if (!isConfirmed)
                    return;
                $.post(self._args.deleteUrl, { id: id }, function () {
                    self.uiElements.listInnerPagingSorting.sendRequest({}, false);
                });
            }, confirmOptions);
        });
    };
    playerHandler.prototype.updateStatus = function () {
        var self = this;
        if (this._args.loggedUser && this._args.loggedUser != '') {
            $.get(self._args.updateStatusUrl, { playerId: self._args.loggedUser }, function (data) {
                self.uiElements.statusContainer.find(".standart-player-info").replaceWith(data);
            });
        }
        this.getRestrictions();
    };
    playerHandler.prototype.getBetsAsString = function () {
        var $bets = this.uiElements.container.find("[data-bet]");
        var $layBets = this.uiElements.container.find("[data-lay-bet]");
        var betsString = "";
        var layBetsString = "";
        $.each($bets, function (index, val) {
            var value = $(val).val();
            if (value) {
                var horseName = $(val).closest("tr").find(".horse-name").text();
                var odds = $(val).closest("tr").find("[data-odds]").text();
                betsString += "<p>" + horseName + " - " + odds + " - " + value + "</p>";
            }
        });
        $.each($layBets, function (index, val) {
            var value = $(val).val();
            if (value) {
                var horseName = $(val).closest("tr").find(".horse-name").text();
                var odds = $(val).closest("tr").find("[data-lay-odds]").text();
                layBetsString += "<p>" + horseName + " - " + odds + " - " + value + "</p>";
            }
        });
        var result = "";
        if (betsString.length > 0) {
            result += "<p>Back Odds:</p>" + betsString;
        }
        if (layBetsString.length > 0) {
            result += "<p>Lay Odds:</p>" + layBetsString;
        }
        return result + "<br/>";
    };
    playerHandler.prototype.isJson = function (str) {
        if (typeof str == "object")
            return true;
        try {
            JSON.parse(str);
        }
        catch (e) {
            return false;
        }
        return true;
    };
    playerHandler.prototype.onSelect = function (dateText) {
        this.uiElements.listInnerPagingSorting.sendRequest({ Date: dateText == "" ? null : dateText }, false);
        this.updateStatus();
    };
    playerHandler.prototype.startConnection = function () {
        var self = this;
        self.connection = null;
        self.connection = new signalR.HubConnectionBuilder()
            .withUrl("/raceoddsPlayer")
            .build();
        self.raceResultsConnection = new signalR.HubConnectionBuilder()
            .withUrl("/playerbethub")
            .build();
        self.raceResultsConnection.start().catch(function (err) { return console.log(err); });
        var refreshStatusAction = function () {
            self.updateStatus();
        };
        this.raceResultsConnection.on("RefreshRaceResults", function (raceId) {
            refreshStatusAction();
        });
        var refreshStatusActionOnExcludeHorse = function (raceId) {
            self.updateIfRaceExists(raceId);
        };
        self.connection.start().catch(function (err) { return console.log(err); });
        var refreshAction = function (raceId, betLocationId, bookmakerId, userId) { self.refreshBets(raceId, betLocationId, bookmakerId, userId); self.updateStatus(); };
        self.raceResultsConnection.on("HorsesExcluded", function (raceId) {
            refreshStatusActionOnExcludeHorse(raceId);
            refreshAction(raceId, null, null, null);
        });
        self.connection.on("UpdateRaceInfoPlayer", function (raceId, betLocationId, bookmakerId, userId) {
            refreshAction(raceId, betLocationId, bookmakerId, userId);
        });
        var stopRaceAction = function (raceId, isStopped) { return self.stopBets(raceId, isStopped); };
        self.connection.on("StopBets", function (raceId, isStopped) {
            stopRaceAction(raceId, isStopped);
        });
    };
    playerHandler.prototype.refreshBets = function (raceId, betLocationId, bookmakerId, userId, clearInputs) {
        if (clearInputs === void 0) { clearInputs = false; }
        var self = this;
        if (!self._lock)
            $.post(self._args.refreshUrl, { raceId: raceId, betLocationId: betLocationId, bookmakerId: bookmakerId, userId: userId }, function (data) {
                self.refreshInner(data, clearInputs);
            });
    };
    playerHandler.prototype.getHistoryMarkup = function (trIndex, betIndex, historyIndex, model) {
        var self = this;
        var result = "<div class='mr-2 mb-2'>";
        var idInp = "<input type='hidden' name='PlayerBets[" + trIndex + "].SaveBetModels[" + betIndex + "].History[" + historyIndex + "].Id' value = '" + model.id + "' />";
        var betTypeInp = "<input type='hidden' name='PlayerBets[" + trIndex + "].SaveBetModels[" + betIndex + "].History[" + historyIndex + "].BetType' value = 'null' />";
        var horseIdInp = "<input type='hidden' name='PlayerBets[" + trIndex + "].SaveBetModels[" + betIndex + "].History[" + historyIndex + "].HorseId' value = '" + model.horseId + "' />";
        var denominatorInp = "<input type='hidden' name='PlayerBets[" + trIndex + "].SaveBetModels[" + betIndex + "].History[" + historyIndex + "].Denominator' value = '" + (model.denominator == null ? 0 : model.denominator) + "' />";
        var numeratorInp = "<input type='hidden' name='PlayerBets[" + trIndex + "].SaveBetModels[" + betIndex + "].History[" + historyIndex + "].Numerator' value = '" + (model.numerator == null ? 0 : model.numerator) + "' />";
        var betInp = "<input type='hidden' name='PlayerBets[" + trIndex + "].SaveBetModels[" + betIndex + "].History[" + historyIndex + "].Bet' value = '" + (model.bet == null ? 0 : model.bet) + "' />";
        var layDenominatorInp = "<input type='hidden' name='PlayerBets[" + trIndex + "].SaveBetModels[" + betIndex + "].History[" + historyIndex + "].LayDenominator' value = '" + (model.layDenominator == null ? 0 : model.layDenominator) + "' />";
        var layNumeratorInp = "<input type='hidden' name='PlayerBets[" + trIndex + "].SaveBetModels[" + betIndex + "].History[" + historyIndex + "].LayNumerator' value = '" + (model.layNumerator == null ? 0 : model.layNumerator) + "' />";
        var layBetInp = "<input type='hidden' name='PlayerBets[" + trIndex + "].SaveBetModels[" + betIndex + "].History[" + historyIndex + "].LayBet' value = '" + (model.layBet == null ? 0 : model.layBet) + "' />";
        result += (idInp + betTypeInp + horseIdInp + denominatorInp + numeratorInp + betTypeInp + betInp + layDenominatorInp + layNumeratorInp + layBetInp);
        var needToShowLayBet = model.layNumerator != null && model.layDenominator != null && model.layNumerator != 0 && model.layDenominator != 0 && model.layBet != null;
        var needToShowBackBet = model.numerator != null && model.denominator != null && model.numerator != 0 && model.denominator != 0 && model.bet != null;
        var betStr = (needToShowBackBet ? self.round(model.numerator) + "/" + self.round(model.denominator) + " - " + model.bet + " " : "")
            + (needToShowLayBet ? self.round(model.layNumerator) + "/" + self.round(model.layDenominator) + " - " + model.layBet : "");
        var placedBet = "<div class=\"placed-bet\"><span class=\"text-truncate\">" + betStr + "</span></div>";
        result += placedBet + "</div>";
        return result;
    };
    playerHandler.prototype.refreshInner = function (data, clearInputs) {
        if (clearInputs === void 0) { clearInputs = false; }
        var self = this;
        $.each(data.playerBetsListModel.playerBets, function (ind, val) {
            var $trs = $("[data-bookmaker-id=''][data-bet-location-id='']", self.uiElements.container);
            $.each($trs, function (i, tr) {
                var $tr = $(tr);
                var $trIndex = parseInt($(tr).closest(".standart-bet").find("[data-index]").attr("data-index"));
                var $nextTr = $tr.next(".placed-bet-row");
                var trHorseId = $tr.attr("data-horse-id");
                $.each(val.saveBetModels, function (j, v) {
                    if (clearInputs) {
                        $tr.find("[data-bet]").val("");
                        $tr.find("[data-lay-bet]").val("");
                    }
                    if (v.horseId.toString() == trHorseId) {
                        if ((v.numerator != 0 && v.denominator != 0) && (v.numerator != null && v.denominator != null)) {
                            $tr.find("[data-bet]").toggle(true);
                        }
                        else {
                            $tr.find("[data-bet]").toggle(false);
                        }
                        if ((v.layNumerator != 0 && v.layDenominator != 0) && (v.layNumerator != null && v.layDenominator != null)) {
                            $tr.find("[data-lay-bet]").toggle(true);
                        }
                        else {
                            $tr.find("[data-lay-bet]").toggle(false);
                        }
                        if (!v.excluded) {
                            $tr.removeClass("disabled");
                            $tr.find("[data-scratched]").text('');
                            $tr.find("[data-excluded-hidden]").attr("value", "False");
                            if ($nextTr.length > 0) {
                                $nextTr.css("display", "");
                            }
                        }
                        else {
                            $tr.addClass("disabled");
                            $tr.find("[data-scratched]").text("Scratched");
                            $tr.find("[data-excluded-hidden]").attr("value", "True");
                            if ($nextTr.length > 0) {
                                $nextTr.css("display", "none");
                            }
                        }
                        var oldNumerator = self.parseOdd($tr.find("[data-numerator]").attr("data-numerator"));
                        var oldDenominator = self.parseOdd($tr.find("[data-denominator]").attr("data-denominator"));
                        var oldLayNumerator = self.parseOdd($tr.find("[data-lay-numerator]").attr("data-lay-numerator"));
                        var oldLayDenominator = self.parseOdd($tr.find("[data-lay-denominator]").attr("data-lay-denominator"));
                        var priceChangeTypeLay = self.getPriceChange(oldLayNumerator, oldLayDenominator, v.layNumerator, v.layDenominator);
                        var priceChangeType = self.getPriceChange(oldNumerator, oldDenominator, v.numerator, v.denominator);
                        self.setOdds(v.numerator, v.denominator, v.layNumerator, v.layDenominator, priceChangeType, priceChangeTypeLay, $tr);
                        if (v.history.length > 0) {
                            var markup_1 = "";
                            if ($nextTr.length == 0) {
                                var style = v.excluded ? "display:none;" : "";
                                markup_1 = "<tr class=\"placed-bet-row\" style=\"" + style + "\"><td colspan=\"8\"><div><div class=\"standart-text gray-dark fw-900 mb-2\">Placed bets:</div> <div class=\"placed-bets-wrapper\">";
                                $.each(v.history, function (jj, h) {
                                    markup_1 += self.getHistoryMarkup($trIndex, j, jj, h);
                                });
                                markup_1 += "</div></div></td></tr>";
                                $tr.after(markup_1);
                            }
                            else {
                                $.each(v.history, function (jj, h) {
                                    markup_1 += self.getHistoryMarkup($trIndex, j, jj, h);
                                });
                                $nextTr.find(".placed-bets-wrapper").html(markup_1);
                            }
                        }
                    }
                });
            });
        });
        self.disableOrEnableSubmit();
    };
    playerHandler.prototype.checkBet = function (maxBet, currentProjBalance, odds, value) {
        var win = value * odds;
        var projBalanceWithBet = currentProjBalance + win;
        return maxBet && maxBet != 0 ? projBalanceWithBet < maxBet : true;
    };
    playerHandler.prototype.checkLayBet = function (maxBet, currentProjBalance, odds, value) {
        var win = value;
        var projBalanceWithBet = currentProjBalance + win;
        return maxBet && maxBet != 0 ? projBalanceWithBet < maxBet : true;
    };
    playerHandler.prototype.checkMaxBet = function (maxBet, odds, value) {
        var win = value * odds;
        return maxBet && maxBet != 0 ? win < maxBet : true;
    };
    playerHandler.prototype.checkLayMaxBet = function (maxBet, odds, value) {
        var win = value;
        return maxBet && maxBet != 0 ? win < maxBet : true;
    };
    playerHandler.prototype.parseOdd = function (odd) {
        var result = 0;
        if (odd && odd != '') {
            result = parseFloat(odd);
        }
        return result;
    };
    playerHandler.prototype.round = function (num) {
        return Math.round((num + Number.EPSILON) * 100) / 100;
    };
    playerHandler.prototype.getPriceChange = function (numerator, denominator, newNumerator, newDenominator) {
        var result = priceChange.NotChanged;
        if (numerator != 0 && denominator != 0 && newDenominator != 0 && newNumerator != 0) {
            var oldK = numerator / denominator;
            var newK = newNumerator / newDenominator;
            if (oldK < newK)
                return priceChange.PriceGoUp;
            if (oldK > newK)
                return priceChange.PriceGoDown;
            return result;
        }
        return result;
    };
    playerHandler.prototype.setOdds = function (numerator, denominator, layNumerator, layDenominator, type, layType, $tr) {
        var $oddsTd = $tr.find("[data-odds]");
        var $layOddsTd = $tr.find("[data-lay-odds]");
        $layOddsTd.attr("data-lay-numerator", layNumerator);
        $layOddsTd.attr("data-lay-denominator", layDenominator);
        $oddsTd.attr("data-numerator", numerator);
        $oddsTd.attr("data-denominator", denominator);
        $tr.find("[data-lay-denominator-hidden]").attr("value", layDenominator);
        $tr.find("[data-lay-numerator-hidden]").attr("value", layNumerator);
        $tr.find("[data-denominator-hidden]").attr("value", denominator);
        $tr.find("[data-numerator-hidden]").attr("value", numerator);
        if ((numerator == 0 && denominator == 0) || (numerator == null && denominator == null)) {
            $oddsTd.text('');
        }
        if ((layNumerator == null && layDenominator == null) || (layDenominator == 0 && layNumerator == 0)) {
            $layOddsTd.text('');
        }
        if ((numerator != 0 && denominator != 0) && (numerator != null && denominator != null)) {
            $oddsTd.text(parseFloat(numerator.toFixed(2)) + "/" + parseFloat(denominator.toFixed(2)));
        }
        if ((layNumerator != null && layDenominator != null) && (layDenominator != 0 && layNumerator != 0)) {
            $layOddsTd.text(parseFloat(layNumerator.toFixed(2)) + "/" + parseFloat(layDenominator.toFixed(2)));
        }
        if (layType == priceChange.NotChanged) {
        }
        if (layType == priceChange.PriceGoDown) {
            $layOddsTd.removeClass("standart-text-green");
            $layOddsTd.addClass("standart-text-red");
        }
        if (layType == priceChange.PriceGoUp) {
            $layOddsTd.removeClass("standart-text-red");
            $layOddsTd.addClass("standart-text-green");
        }
        if (type == priceChange.NotChanged) {
        }
        if (type == priceChange.PriceGoDown) {
            $oddsTd.removeClass("standart-text-green");
            $oddsTd.addClass("standart-text-red");
        }
        if (type == priceChange.PriceGoUp) {
            $oddsTd.removeClass("standart-text-red");
            $oddsTd.addClass("standart-text-green");
        }
    };
    playerHandler.prototype.stopBets = function (raceId, isStopped) {
        var self = this;
        var $textContainers = self.uiElements.container.find("[data-race-message-id='" + raceId + "']");
        var $form = $("form", $(".raceBets"));
        $form.attr("data-stopped", isStopped ? "true" : "false");
        $.each($textContainers, function (index, val) {
            var $textContainer = $(val);
            if (isStopped) {
                $textContainer.html("<strong>Bets has been stopped</strong>");
                $(".raceBets", self.uiElements.container).find(":submit").prop("disabled", true);
            }
            else {
                $textContainer.html("");
                $(".raceBets", self.uiElements.container).find(":submit").prop("disabled", false);
            }
        });
    };
    playerHandler.prototype.disableOrEnableSubmit = function () {
        var $form = $("form", $(".raceBets"));
        var isStopped = $form.attr("data-stopped");
        if (isStopped != "true") {
            var $bets = $("[data-bet], [data-lay-bet]");
            var $submitBtn = $("input[type='submit']", $form);
            var notEmptyBets = $bets.filter(function (index, $el) {
                var val = $($el).val();
                return val && val != '' && parseFloat(val) > 0;
            });
            if (notEmptyBets.length > 0) {
                $submitBtn.prop('disabled', false);
            }
            else {
                $submitBtn.prop('disabled', true);
            }
        }
    };
    playerHandler.prototype.onRefreshRaceList = function () {
        var self = this;
        var $items = self.uiElements.container.find(".race");
        var $noRf = self.uiElements.container.find(".standart-empty-state");
        var $bets = $(".race-bets-container", self.uiElements.container);
        var $noBetsHtml = "<div class='standart-text gray fz-18 fw-500'>Please, select a race to the left to view detail</div>";
        if ($items.length == 0) {
            $noRf.removeClass("d-none");
            $noRf.addClass("d-flex");
            $bets.removeClass("d-lg-flex d-flex");
            $bets.addClass("d-none");
        }
        else {
            $noRf.removeClass("d-flex");
            $noRf.addClass("d-none");
            $bets.addClass("d-lg-flex d-flex");
            $bets.removeClass("d-none");
            $bets.find(".raceBets").html($noBetsHtml);
        }
    };
    playerHandler.prototype.getRestrictions = function () {
        var $self = this;
        $.get($self._args.getRestrictionsUrl, function (data) {
            $self._restrictions = data;
            $self.getBalances();
        });
    };
    playerHandler.prototype.calcBets = function () {
        var $form = $("form", $(".raceBets"));
        var $bets = $("[data-bet], [data-lay-bet]", $form).closest("tr");
        var startBalanceWithBets = 0;
        $.each($bets, function (ind, val) {
            var $elTr = $(val);
            var value = $elTr.find("[data-bet]").val();
            var layValue = $elTr.find("[data-lay-bet]").val();
            if ((!value || value == "") && (!layValue || layValue == ""))
                return;
            var layNumerator = $elTr.find("[data-lay-numerator]").attr("data-lay-numerator");
            var layDenominator = $elTr.find("[data-lay-denominator]").attr("data-lay-denominator");
            var layVal = 0;
            var backVal = 0;
            if (layNumerator != "" && layDenominator != "" && layValue != "") {
                layVal = parseFloat(layValue) * (parseFloat(layNumerator) / parseFloat(layDenominator));
            }
            if (value != "") {
                backVal = parseFloat(value);
            }
            var winBet = backVal + layVal;
            startBalanceWithBets += winBet;
        });
        return startBalanceWithBets;
    };
    playerHandler.prototype.calculateExistedBets = function () {
        var $form = $("form", $(".raceBets"));
        var $bets = $("[data-bet]", $form).closest("tr");
        var startBalanceWithBets = 0;
        var maxBet = 0;
        var maxLayBet = 0;
        $.each($bets, function (ind, val) {
            var $elTr = $(val);
            var value = parseFloat($elTr.find("[data-bet]").val());
            var layValue = parseFloat($elTr.find("[data-lay-bet]").val());
            var $oddsTd = $($elTr).closest("tr").find("[data-odds]");
            var numerator = parseFloat($oddsTd.attr("data-numerator"));
            var denominator = parseFloat($oddsTd.attr("data-denominator"));
            var layNumerator = parseFloat($oddsTd.attr("data-lay-numerator"));
            var layDenominator = parseFloat($oddsTd.attr("data-lay-denominator"));
            if (value > maxBet) {
                maxBet = value * (numerator / denominator);
            }
            if (layValue > maxBet) {
                maxLayBet = layValue * (layNumerator / layDenominator) + layValue;
            }
        });
        startBalanceWithBets += (maxBet + maxLayBet);
        return startBalanceWithBets;
    };
    playerHandler.prototype.calculateBetsSum = function () {
        var $form = $("form", $(".raceBets"));
        var $bets = $("[data-bet]", $form).closest("tr");
        var startBets = 0;
        $.each($bets, function (ind, val) {
            var $elTr = $(val);
            var value = isNaN(parseFloat($elTr.find("[data-bet]").val())) ? 0 : parseFloat($elTr.find("[data-bet]").val());
            var layValue = isNaN(parseFloat($elTr.find("[data-lay-bet]").val())) ? 0 : parseFloat($elTr.find("[data-lay-bet]").val());
            startBets += ((value !== null && value !== void 0 ? value : 0) + (layValue !== null && layValue !== void 0 ? layValue : 0));
        });
        return startBets;
    };
    playerHandler.prototype.getBalances = function () {
        var self = this;
        $.get(self._args.getBalanceUrl, function (data) {
            self._balance = data;
        });
    };
    playerHandler.prototype.validateOverallBalance = function (value, $el) {
        var self = this;
        if (!value || value == '')
            return true;
        if ((self._restrictions.overallBalanceRestriction && self._restrictions.overallBalanceRestriction != 0) && (self._balance && self._balance.currentBalance.currentBalanceWithProjectedWin && self._balance.currentBalance.currentBalanceWithProjectedWin != 0)) {
            var overallBalanceRestriction = self._restrictions.overallBalanceRestriction;
            var currentBalance = self._balance.currentBalance.currentBalanceWithProjectedWin;
            var allBetsOnView = self.calculateExistedBets();
            if ((currentBalance + allBetsOnView) > overallBalanceRestriction)
                return false;
            return true;
        }
        return true;
    };
    playerHandler.prototype.getProjectedWin = function (raceId, horseId) {
        var url = this._args.getProjectedWinUrl + "?raceId=" + raceId + "&horseId=" + horseId;
        return $.ajax({ method: 'get', url: url, dataType: 'json', async: false });
    };
    playerHandler.prototype.validatePlayerBalance = function (value, $el) {
        var self = this;
        if (!value || value == '')
            return true;
        if (self._balance && self._balance.currentBalance && self._balance.currentBalance.currentBalance != 0) {
            var currentBalance = self._balance.currentBalance.currentBalance;
            var allBetsOnView = self.calculateBetsSum();
            if ((currentBalance - allBetsOnView) < 0)
                return false;
            return true;
        }
        return true;
    };
    playerHandler.prototype.updateIfRaceExists = function (raceId) {
        var self = this;
        if (self.uiElements.container.find("[data-race-id='" + raceId + "']").length > 0) {
            self.updateStatus();
        }
    };
    playerHandler.prototype.addValidationsForForm = function () {
        var $form = $("form", $(".raceBets"));
        var self = this;
        var maxBet = $form.find("#MaxBet").val();
        var raceId = $form.find("#RaceId").val();
        if ((maxBet && maxBet != '') || (self._restrictions && self._restrictions.amountToWinRestriction && self._restrictions.amountToWinRestriction != 0)) {
            $.validator.addMethod("isBetValid", function (value, element) {
                if (!value)
                    return true;
                var horseId = $(element).closest("tr").attr("data-horse-id");
                self.getProjectedWin(parseInt(raceId), parseInt(horseId)).done(function (data) {
                    self._projectedWin = data;
                });
                if ($(element).hasClass("lay-input")) {
                    var $oddsTd = $(element).closest("tr").find("[data-lay-odds]");
                    var numerator = $oddsTd.attr("data-lay-numerator");
                    var denominator = $oddsTd.attr("data-lay-denominator");
                    var odds = parseFloat(numerator) / parseFloat(denominator);
                    var maxRestrictionOnPlayer = self._restrictions && self._restrictions.amountToWinRestriction && self._restrictions.amountToWinRestriction != 0
                        ? self.checkLayBet(self._restrictions.amountToWinRestriction, self._projectedWin.projectedWinAmount, odds, parseFloat(value))
                        : true;
                    return maxRestrictionOnPlayer;
                }
                else {
                    var $oddsTd = $(element).closest("tr").find("[data-odds]");
                    var numerator = $oddsTd.attr("data-numerator");
                    var denominator = $oddsTd.attr("data-denominator");
                    var odds = parseFloat(numerator) / parseFloat(denominator);
                    var maxRestrictionOnPlayer = self._restrictions && self._restrictions.amountToWinRestriction && self._restrictions.amountToWinRestriction != 0
                        ? self.checkBet(self._restrictions.amountToWinRestriction, self._projectedWin.projectedWinAmount, odds, parseFloat(value))
                        : true;
                    return maxRestrictionOnPlayer;
                }
            }, function (params, element) {
                var value = $(element).val();
                if (!value)
                    return "";
                return "Please check win limit. Limit is:" + self._restrictions.amountToWinRestriction;
            });
        }
        if ((maxBet && maxBet != '')) {
            $.validator.addMethod("isMaxBetValid", function (value, element) {
                if (!value)
                    return true;
                if ($(element).hasClass("lay-input")) {
                    var $oddsTd = $(element).closest("tr").find("[data-lay-odds]");
                    var numerator = $oddsTd.attr("data-lay-numerator");
                    var denominator = $oddsTd.attr("data-lay-denominator");
                    var odds = parseFloat(numerator) / parseFloat(denominator);
                    var maxRestrictionOnRaceError = maxBet && maxBet != '' ? self.checkLayMaxBet(parseFloat(maxBet), odds, parseFloat(value)) : true;
                    return maxRestrictionOnRaceError;
                }
                else {
                    var $oddsTd = $(element).closest("tr").find("[data-odds]");
                    var numerator = $oddsTd.attr("data-numerator");
                    var denominator = $oddsTd.attr("data-denominator");
                    var odds = parseFloat(numerator) / parseFloat(denominator);
                    var maxRestrictionOnRaceError = maxBet && maxBet != '' ? self.checkMaxBet(parseFloat(maxBet), odds, parseFloat(value)) : true;
                    return maxRestrictionOnRaceError;
                }
            }, function (params, element) {
                var value = $(element).val();
                if (!value)
                    return "";
                return "Please check win limit. Limit is:" + maxBet;
            });
        }
        var $bets = $form.find("[data-bet], [data-lay-bet]");
        if (self._restrictions.overallBalanceRestriction && self._restrictions.overallBalanceRestriction != 0) {
            $.validator.addMethod("isOverallBalanceValid", function (val, element) {
                return self.validateOverallBalance(val, $(element));
            }, "Overall balance for user was exceeded");
        }
        $.validator.addMethod("isOverallBalanceValidForUser", function (val, element) {
            return self.validatePlayerBalance(val, $(element));
        }, "You cannot place a bet because your balance will become negative.");
        if ((self._restrictions.overallBalanceRestriction && self._restrictions.overallBalanceRestriction != 0)
            || ((maxBet && maxBet != '') || (self._restrictions && self._restrictions.amountToWinRestriction && self._restrictions.amountToWinRestriction != 0)) || (self._balance && self._balance.currentBalance)) {
            var opts_1 = {
                success: function ($label, $input) {
                    $($input).removeClass("input-validation-error is-invalid");
                },
                errorPlacement: function (error, element) {
                    var placement = $(element).data('error');
                    if (placement) {
                        $(placement).append(error);
                    }
                    else {
                        error.insertAfter(element);
                    }
                    $(element).addClass("input-validation-error is-invalid");
                    error.insertAfter(element);
                },
                rules: {}
            };
            var optsJson_1 = {};
            optsJson_1.isOverallBalanceValidForUser = true;
            if ((self._restrictions.overallBalanceRestriction && self._restrictions.overallBalanceRestriction != 0)) {
                optsJson_1.isOverallBalanceValid = true;
            }
            if (((maxBet && maxBet != ''))) {
                optsJson_1.isMaxBetValid = true;
            }
            if (((self._restrictions && self._restrictions.amountToWinRestriction && self._restrictions.amountToWinRestriction != 0))) {
                optsJson_1.isBetValid = true;
            }
            $.each($bets, function (index, v) {
                var $b = $(v);
                opts_1.rules[$b.attr('name')] = optsJson_1;
            });
            $form.validate(opts_1);
        }
    };
    return playerHandler;
}());
var priceChange;
(function (priceChange) {
    priceChange[priceChange["PriceGoUp"] = 1] = "PriceGoUp";
    priceChange[priceChange["PriceGoDown"] = 2] = "PriceGoDown";
    priceChange[priceChange["NotChanged"] = 3] = "NotChanged";
})(priceChange || (priceChange = {}));
var playerHandlerArgs = (function () {
    function playerHandlerArgs() {
    }
    return playerHandlerArgs;
}());
var projectedWinModel = (function () {
    function projectedWinModel() {
    }
    return projectedWinModel;
}());
var playerRestrictions = (function () {
    function playerRestrictions() {
    }
    return playerRestrictions;
}());
var playerBalanceModel = (function () {
    function playerBalanceModel() {
    }
    return playerBalanceModel;
}());
var playerCurrentBalanceModel = (function () {
    function playerCurrentBalanceModel() {
    }
    return playerCurrentBalanceModel;
}());
var playerBetListModel = (function () {
    function playerBetListModel() {
    }
    return playerBetListModel;
}());
var playerBetModel = (function () {
    function playerBetModel() {
    }
    return playerBetModel;
}());
var playerBetItemModel = (function () {
    function playerBetItemModel() {
    }
    return playerBetItemModel;
}());
var exportFilter = (function () {
    function exportFilter(container) {
        var _this = this;
        this.uiElements = {
            container: null,
            filterForm: null,
            exportForm: null
        };
        this.uiElements.container = $(container);
        this.uiElements.filterForm = $(".filter", this.uiElements.container);
        this.uiElements.exportForm = $(".export-form", this.uiElements.container);
        var submitAction = function () { _this.submitForm(); site.validators.refreshValidators(_this.uiElements.container); };
        $("#Date", this.uiElements.container).datepicker({ dateFormat: "mm/dd/yy", onClose: submitAction });
        $(".user-ids", this.uiElements.container).select2({
            placeholder: 'All Operators',
            containerCssClass: 'form-control',
            dropdownAutoWidth: true
        });
        site.validators.refreshValidators(this.uiElements.container);
        this.subscribeToEvents();
    }
    exportFilter.prototype.subscribeToEvents = function () {
        var _this = this;
        var submitAction = function () { return _this.submitForm(); };
        this.uiElements.filterForm.on("change", "#TrackId", submitAction);
        this.uiElements.filterForm.on("change", "#UserId", submitAction);
    };
    exportFilter.prototype.submitForm = function () {
        var _this = this;
        this.uiElements.filterForm.validate();
        var updateRacesAction = function (data) {
            _this.uiElements.exportForm.html(data);
        };
        if (this.uiElements.filterForm.valid()) {
            $.post(this.uiElements.filterForm.attr("action"), this.uiElements.filterForm.serialize(), function (data) {
                updateRacesAction(data);
            });
        }
    };
    return exportFilter;
}());
var raceAjaxImport = (function () {
    function raceAjaxImport(options) {
        this.uiElements = {
            container: null,
            fileInput: null
        };
        this.options = options;
        this.uiElements.container = $(options.container);
        this.uiElements.fileInput = $(".file-input-upload", this.uiElements.container);
        this.initUploader();
    }
    raceAjaxImport.prototype.initUploader = function () {
        var _this = this;
        var processResult = function (data) { return _this.processResult(data); };
        this.uiElements.fileInput.fileupload({
            url: this.options.url,
            paramName: "Json",
            autoUpload: true,
            fileInput: $(this.uiElements.fileInput),
            replaceFileInput: true,
            start: function (e, data) {
            },
            done: function (e, data) {
                processResult(data.result);
            },
            fail: function (e, data) {
                processResult(data.result);
            }
        });
    };
    raceAjaxImport.prototype.processResult = function (result) {
        if (!result.success) {
            var dialogResult_1 = appDialogShow({
                body: this.getErrorMessage(result),
                title: "Error",
                dialogClass: "min-h-200 dialog-450px big-padding",
                headerClass: "border-bottom-0",
                buttons: [
                    {
                        text: 'OK', buttonClass: 'btn-primary', click: function () { dialogResult_1.close(); }
                    }
                ]
            });
        }
        else {
            if (result.reload) {
                setTimeout(function () { return window.location.reload(); }, 2500);
            }
            if (result.redirect) {
                window.location.href = result.redirect;
            }
        }
    };
    raceAjaxImport.prototype.getErrorMessage = function (response) {
        return response.serializtionError ? response.serializtionError : response.saveError ? response.saveError : "";
    };
    return raceAjaxImport;
}());
var ajaxUploadOptions = (function () {
    function ajaxUploadOptions() {
    }
    return ajaxUploadOptions;
}());
var UploadResult = (function () {
    function UploadResult() {
    }
    return UploadResult;
}());
var raceExcelExportDialog = (function () {
    function raceExcelExportDialog(opts) {
        this.uiElements = {
            container: null,
            importButton: null
        };
        this.options = opts;
        this.uiElements.container = $(this.options.container);
        this.uiElements.importButton = $(".export-to-excel", this.uiElements.container);
        this.initDialog();
    }
    raceExcelExportDialog.prototype.initDialog = function () {
        var _this = this;
        var saveButtonAction = function (dialogContainer, exportActionType) {
            var formToSend = $(".export-form", dialogContainer.container);
            var $form = $(formToSend);
            $("#ExportActionType", $form).val(exportActionType);
            $form.validate();
            if ($form.valid()) {
                $form.submit();
                dialogContainer.close();
            }
        };
        var cancelButtonAction = function (dialogContainer) {
            dialogContainer.close();
        };
        var saveAsLog = "1";
        var saveAsTimeTable = "2";
        var saveToteOdds = "3";
        this.uiElements.importButton.click(function (e) {
            e.preventDefault();
            var $btn = $(e.target);
            $btn.prop("disabled", true);
            $.get(_this.options.url, function (data) {
                $btn.prop("disabled", false);
                var dialogResult = appDialogShow({
                    body: data,
                    title: "Export",
                    dialogClass: "dialog-900px min-h-400",
                });
                dialogResult.container.on("shown.bs.modal", function () { new exportFilter(dialogResult.container); });
                dialogResult.container.on("click", ".btn-secondary", function () {
                    cancelButtonAction(dialogResult);
                });
                dialogResult.container.on("click", "[data-report-type]", function (e) {
                    e.preventDefault();
                    var target = $(e.target).closest("a").attr("data-report-type");
                    saveButtonAction(dialogResult, target);
                });
            });
        });
    };
    return raceExcelExportDialog;
}());
var raceExcelExportDialogOptions = (function () {
    function raceExcelExportDialogOptions() {
    }
    return raceExcelExportDialogOptions;
}());
var raceAssignmentEdit = (function () {
    function raceAssignmentEdit(container, bookmakersUrl, betLocationsUrl, raceId) {
        var _this = this;
        this.uiElements = {
            container: null,
            bookmakersDropdown: null,
            locationsDropdown: null,
            usersLookup: null
        };
        this.getBetLocationsUrl = betLocationsUrl;
        this.getBookmakersUrl = bookmakersUrl;
        this.raceId = raceId;
        this.uiElements.container = $(container);
        this.uiElements.bookmakersDropdown = $(".bookmakers-dropdown", this.uiElements.container);
        this.uiElements.locationsDropdown = $(".locations-dropdown", this.uiElements.container);
        this.uiElements.usersLookup = $(".users-lookup", this.uiElements.container);
        if (this.getBetLocationsUrl && this.getBookmakersUrl) {
            this.uiElements.locationsDropdown.change(function ($event) {
                _this.onLocationChanged();
            });
            this.uiElements.bookmakersDropdown.change(function ($event) {
                _this.onBookmakerChanged();
            });
        }
        this.uiElements.usersLookup.on("keyup", function ($event) {
            var text = $($event.target).val();
            _this.filterText(text, $($event.target).parents(".filter-container"));
        });
        this.uiElements.container.on("click", ".minute-text", function (e) {
            var isChecked = $(e.target).closest("input[type='checkbox']").is(":checked");
            var $targetToShow = $(e.target).closest(".check-container").find(".user-timeout");
            var $inputToReset = $(".form-control", $targetToShow);
            console.log($inputToReset);
            if (isChecked) {
                $inputToReset.prop('disabled', false);
            }
            else {
                $inputToReset.val("");
                $inputToReset.prop('disabled', true);
            }
        });
    }
    raceAssignmentEdit.prototype.filterText = function (searchTerm, container) {
        var $checkboxes = $("input[type='checkbox']", container);
        if (searchTerm == '' || searchTerm == null) {
            $.each($checkboxes, function (index, $value) {
                $($value.closest(".checkbox-item")).toggle(true);
            });
            return;
        }
        $.each($checkboxes, function (index, $value) {
            var isSelected = $($value).is(":checked");
            if (!isSelected) {
                var text = $($value).parent().text().toLowerCase();
                var $checkBoxContainer = $($value.closest(".checkbox-item"));
                if (text.indexOf(searchTerm.toLowerCase()) > -1) {
                    $checkBoxContainer.toggle(true);
                }
                else {
                    $checkBoxContainer.toggle(false);
                }
            }
        });
    };
    raceAssignmentEdit.prototype.onBookmakerChanged = function () {
        var _this = this;
        $.get(this.getBetLocationsUrl, { raceId: this.raceId, bookmakerId: this.uiElements.bookmakersDropdown.val() }, function (data) {
            _this.updateDropdown(_this.uiElements.locationsDropdown, data);
        });
    };
    raceAssignmentEdit.prototype.onLocationChanged = function () {
        var _this = this;
        $.get(this.getBookmakersUrl, { raceId: this.raceId, betLocationId: this.uiElements.locationsDropdown.val() }, function (data) {
            _this.updateDropdown(_this.uiElements.bookmakersDropdown, data);
        });
    };
    raceAssignmentEdit.prototype.updateDropdown = function (dropdown, selectList) {
        var $dropdown = $(dropdown);
        var value = $dropdown.val();
        $dropdown.val("");
        var firstOption = $dropdown.find("option")[0];
        $dropdown.html("");
        $dropdown.append(firstOption);
        $.each(selectList, function (ind, val) {
            $dropdown.append($("<option></option>").val(val.value).text(val.text));
        });
        $dropdown.val(value);
    };
    return raceAssignmentEdit;
}());
var raceAssignmentList = (function () {
    function raceAssignmentList(container, options) {
        var _this = this;
        this.uiElements = {
            container: null,
            listContainer: null,
            copyLink: null
        };
        this.uiElements.container = $(container);
        this.uiElements.listContainer = $(".list-container", this.uiElements.container);
        this.uiElements.copyLink = $(".copy-link", this.uiElements.container);
        this.options = options;
        this.uiElements.container.on("click", ".edit-link", function ($event) {
            $event.preventDefault();
            _this.openDialog($($event.target));
        });
        this.uiElements.container.on("click", ".delete-link", function ($event) {
            $event.preventDefault();
            _this.onDelete($($event.target));
        });
        this.uiElements.copyLink.click(function (e) {
            e.preventDefault();
            _this.openCopyDialog();
        });
    }
    raceAssignmentList.prototype.updateList = function () {
        var _this = this;
        $.get(this.options.assignmentListUrl, { raceId: this.options.raceId }, function (data) {
            _this.uiElements.listContainer.html(data);
            if (_this.uiElements.listContainer.find("table").length > 0) {
                $(".copy-lnk", _this.uiElements.container).toggle(true);
            }
            else {
                $(".copy-lnk", _this.uiElements.container).toggle(false);
            }
        });
    };
    raceAssignmentList.prototype.onDelete = function ($el) {
        var _this = this;
        var id = $el.closest("[data-id]").attr('data-id');
        var confirmOptions = new appConfirmDialogOptions();
        var deleteFunction = function () { return $.post(_this.options.deleteAssignmentUrl, { id: id }, function () { return _this.updateList(); }); };
        site.dialogs.confirm("Are you sure?", function (isConfirmed) {
            if (!isConfirmed)
                return;
            deleteFunction();
        }, confirmOptions);
    };
    raceAssignmentList.prototype.openCopyDialog = function () {
        var dialogOptions = {
            fetchParams: this.options.copyParams ? this.options.copyParams : { raceId: this.options.raceId },
            saveBtnText: "Copy",
            title: this.options.copyDialogTitle ? this.options.copyDialogTitle : "Copy Assignments",
            dialogClass: "dialog-650px"
        };
        appSaveFormDialog(this.options.copyUrl, dialogOptions);
    };
    raceAssignmentList.prototype.openDialog = function ($el) {
        var _this = this;
        var id = $el.closest("[data-id]").attr('data-id');
        var dialogOptions = {
            fetchParams: { id: id, raceId: this.options.raceId },
            saveBtnText: "Save",
            title: this.options.editDialogLabel ? this.options.editDialogLabel : "Edit Race Assignment",
            dialogClass: "dialog-1100px"
        };
        appSaveFormDialog(this.options.editUrl, dialogOptions).done(function () { return _this.updateList(); });
    };
    return raceAssignmentList;
}());
var raceAssignmentListOptions = (function () {
    function raceAssignmentListOptions() {
    }
    return raceAssignmentListOptions;
}());
var raceHorseEdit = (function () {
    function raceHorseEdit(container) {
        this.uiElements = {
            container: null,
            raceHorseTextBox: null,
            horseIdInput: null
        };
        this.uiElements.container = $(container);
        this.uiElements.raceHorseTextBox = $("[data-autocomplete-url]", this.uiElements.container);
        this.uiElements.horseIdInput = $("#HorseId", this.uiElements.container);
        this.subscribeToEvents();
    }
    raceHorseEdit.prototype.subscribeToEvents = function () {
        var _this = this;
        this.uiElements.raceHorseTextBox.on("autocompleteselect", function (event, ui) {
            _this.uiElements.horseIdInput.val(ui.item.data);
        });
    };
    return raceHorseEdit;
}());
var raceHorseList = (function () {
    function raceHorseList(container, options) {
        var _this = this;
        this.uiElements = {
            container: null,
            listContainer: null
        };
        this.uiElements.container = $(container);
        this.uiElements.listContainer = $(".horses-list", this.uiElements.container);
        this.options = options;
        this.uiElements.container.on("click", ".edit-link", function ($evt) {
            $evt.preventDefault();
            _this.openDialog($($evt.target));
        });
        this.uiElements.container.on("click", ".delete-link", function ($evt) {
            $evt.preventDefault();
            _this.onDelete($($evt.target));
        });
        this.sortable = this.initSortable();
    }
    raceHorseList.prototype.openDialog = function ($el) {
        var _this = this;
        var id = $el.attr('data-id');
        var dialogOptions = {
            fetchParams: { id: id, raceId: this.options.raceId },
            saveBtnText: "Add",
            title: "Add Horse"
        };
        appSaveFormDialog(this.options.addHorseUrl, dialogOptions).done(function () { return _this.updateList(); });
    };
    raceHorseList.prototype.onDelete = function ($el) {
        var _this = this;
        var horseId = $el.closest("[data-horse-id]").attr("data-horse-id");
        var confirmOptions = new appConfirmDialogOptions();
        var deleteFunction = function () { return $.post(_this.options.deleteUrl, { HorseId: horseId, RaceId: _this.options.raceId }, function () { return _this.updateList(); }); };
        site.dialogs.confirm("Are you sure?", function (isConfirmed) {
            if (!isConfirmed)
                return;
            deleteFunction();
        }, confirmOptions);
    };
    raceHorseList.prototype.updateList = function () {
        var _this = this;
        $.get(this.options.getList, { raceId: this.options.raceId }, function (data) {
            if (_this.sortable) {
                _this.sortable.dispose();
            }
            _this.uiElements.listContainer.html(data);
            _this.sortable = _this.initSortable();
        });
    };
    raceHorseList.prototype.initSortable = function () {
        var _this = this;
        var sort = new raceHorseSorting($(this.uiElements.listContainer), this.options.saveSortingUrl, this.options.raceId, function () { _this.updateList(); });
        return sort;
    };
    return raceHorseList;
}());
var raceHorseOptions = (function () {
    function raceHorseOptions() {
    }
    return raceHorseOptions;
}());
var raceHorseSorting = (function () {
    function raceHorseSorting(container, saveUrl, raceId, updateCallback, realtimeUpdate) {
        if (realtimeUpdate === void 0) { realtimeUpdate = true; }
        this.uiElements = {
            container: null
        };
        this.uiElements.container = $(container);
        this.updateListFunction = updateCallback;
        this.saveUrl = saveUrl;
        this.raceId = raceId;
        this.realtimeUpdate = realtimeUpdate;
        this.init();
    }
    raceHorseSorting.prototype.init = function () {
        var _this = this;
        this.sortable = $(".sort-items-container", this.uiElements.container);
        this.sortable.sortable({
            axis: "y",
            tolerance: "pointer",
            items: "[data-sortable-item]",
            update: function (event, ui) { return _this.onUpdate(event, ui); }
        });
    };
    raceHorseSorting.prototype.onUpdate = function (event, ui) {
        var _this = this;
        if (this.realtimeUpdate) {
            var items = this.sortable.sortable("toArray", { attribute: 'data-sortable-item' });
            var model = {
                RaceId: this.raceId,
                HorsesIds: items
            };
            $.post(this.saveUrl, model, function () {
                _this.updateListFunction();
            });
        }
        else {
            this.updateListFunction();
        }
    };
    raceHorseSorting.prototype.dispose = function () {
        if (this.sortable) {
            this.sortable.sortable("destroy");
        }
    };
    return raceHorseSorting;
}());
var raceHorseResultList = (function () {
    function raceHorseResultList(container, options) {
        var _this = this;
        this.uiElements = {
            container: null,
            defineBtn: null,
            listContainer: null
        };
        this.uiElements.container = $(container);
        this.uiElements.listContainer = $(".horse-results-list", this.uiElements.container);
        this.uiElements.defineBtn = $(".define-btn", this.uiElements.container);
        this.options = options;
        if (options.sorting) {
            this.sortable = this.initSortable();
        }
        this.uiElements.defineBtn.click(function (e) {
            _this.onDefineClick();
        });
    }
    raceHorseResultList.prototype.onDefineClick = function () {
        var _this = this;
        if (this.isFormExists()) {
            var $form = this.uiElements.listContainer.find("form");
            $form.validate();
            if ($form.valid()) {
                $.post(this.options.getListUrl, $form.serialize(), function (data) { _this.options.resultExists = true; _this.updateList(); });
            }
        }
        else {
            this.updateList();
        }
    };
    raceHorseResultList.prototype.updateList = function () {
        var _this = this;
        $.get(this.options.getListUrl, { raceId: this.options.raceId, resultsDefined: this.options.resultExists }, function (data) {
            if (_this.sortable) {
                _this.sortable.dispose();
            }
            _this.uiElements.listContainer.html(data);
            _this.sortable = _this.initSortable();
            _this.toggleButton();
        });
    };
    raceHorseResultList.prototype.toggleButton = function () {
        if (this.isFormExists()) {
            this.uiElements.defineBtn.text("Save");
            this.uiElements.defineBtn.removeClass("btn-success");
            this.uiElements.defineBtn.addClass("btn-primary");
        }
        else {
            this.uiElements.defineBtn.text("Define");
            this.uiElements.defineBtn.removeClass("btn-primary");
            this.uiElements.defineBtn.addClass("btn-success");
        }
    };
    raceHorseResultList.prototype.initSortable = function () {
        var _this = this;
        var sort = new raceHorseSorting($(this.uiElements.listContainer), this.options.saveSortingUrl, this.options.raceId, function () { _this.setOrdinals(); }, false);
        return sort;
    };
    raceHorseResultList.prototype.setOrdinals = function () {
        var $ordinals = this.uiElements.listContainer.find("[data-ordinal]");
        var index = 1;
        $.each($ordinals, function (ind, val) {
            $(val).val(index);
            index++;
        });
    };
    raceHorseResultList.prototype.isFormExists = function () {
        return this.uiElements.listContainer.find("form").length > 0;
    };
    return raceHorseResultList;
}());
var raceHorseResultOptions = (function () {
    function raceHorseResultOptions() {
        this.sorting = true;
    }
    return raceHorseResultOptions;
}());
var raceOddEdit = (function () {
    function raceOddEdit(container, horseOddsUrl, raceId) {
        var _this = this;
        this.uiElements = {
            container: null,
            bookmakerDropdown: null,
            listContainer: null
        };
        this.uiElements.container = $(container);
        this.uiElements.listContainer = $(".odds-tab", this.uiElements.container);
        this.uiElements.bookmakerDropdown = $(".bookmaker-dropdown", this.uiElements.container);
        this.raceId = raceId;
        this.horseOddsUrl = horseOddsUrl;
        this.uiElements.bookmakerDropdown.change(function () { return _this.onBookmakerChange(); });
        this.uiElements.listContainer.submit(function (event) { return _this.onSubmit(event); });
        this.uiElements.container.on("keyup", ".numerator", function (e) {
            var val = $(e.target).val();
            var $denominator = $(e.target).closest(".row").find(".denominator");
            if (val.indexOf(".") != -1) {
                $denominator.val(1).addClass("readonly-field");
            }
            else {
                $denominator.removeClass("readonly-field");
            }
        });
    }
    raceOddEdit.prototype.onBookmakerChange = function () {
        var _this = this;
        var bookmakerId = this.uiElements.bookmakerDropdown.val();
        $.get(this.horseOddsUrl, { raceId: this.raceId, selectedBookmakerId: bookmakerId }, function (data) {
            _this.uiElements.listContainer.html(data);
        });
    };
    raceOddEdit.prototype.onSubmit = function ($event) {
        var _this = this;
        $event.preventDefault();
        var $form = $($event.target);
        $form.find("input[type='submit']").prop("disabled", true);
        $form.validate();
        if (!$form.valid()) {
            $form.find("input[type='submit']").prop("disabled", true);
            return;
        }
        $.post($form.attr("action"), $form.serialize(), function (data) {
            _this.uiElements.listContainer.html(data);
        });
    };
    return raceOddEdit;
}());
var reportMapHandler = (function () {
    function reportMapHandler(args) {
        var _this = this;
        this.uiElements = {
            container: null,
            filterContainer: null,
            messageContainer: null
        };
        this.markers = [];
        this.itemTemplate = _.template("<div class='slider-item' style='width:475px; height:300px;<%=model.display ? '' : 'display:none;'%>'>" +
            "<div class=''>" +
            "<h5 class='modal-title'>" +
            "<%=model.userFullName%> - <%=model.updatedDate%>" +
            "</h5>" +
            "</div>" +
            "<div class=''>" +
            "<div class=''>" +
            "<span><%=model.trackName%> - <%=model.raceNumber%> - <%=model.raceStartDate%></span>" +
            "</div>" +
            "<div class=''>" +
            "<p><% if (model.horseOdds.length > 0) {%>" +
            "<% _.each(model.horseOdds, function (odd) { %>" +
            "<div style='<%=odd.excluded ? 'text-decoration: line-through;' : ''%>'><%=odd.numerator%>/<%=odd.denominator%> - <%=odd.horseName%></div>" +
            "<div style='<%=odd.excluded ? 'text-decoration: line-through;' : ''%>'><%=odd.layNumerator%>/<%=odd.layDenominator%> - <%=odd.horseName%></div>" +
            "<% }); %>" +
            "<%}%>" +
            "<% if (model.type == 'ToteOdd') {%>" +
            "<div><strong style='font-weight: 700;'><%=model.horseName != null ? model.horseName : 'Pool'%></strong></div>" +
            "<div>WNP:<%=model.wnp ? model.wnp : '-'%></div>" +
            "<div>SHP:<%=model.shp ? model.shp : '-'%></div>" +
            "<div>THP:<%=model.thp ? model.thp : '-'%></div>" +
            "<div>PLP:<%=model.plp ? model.plp : '-'%></div>" +
            "<div>FCP:<%=model.fcp ? model.fcp : '-'%></div>" +
            "<div>TNP:<%=model.tnp ? model.tnp : '-'%></div>" +
            "<div>QNP:<%=model.qnp ? model.qnp : '-'%></div>" +
            "<%}%>" +
            "</p>" +
            "</div>" +
            "</div>" +
            "</div>");
        this._args = args;
        this.uiElements.container = $(args.container);
        this.uiElements.filterContainer = $(".users-filter", this.uiElements.container);
        this.uiElements.messageContainer = $("#not-found", this.uiElements.container);
        this.addMapsScript();
        this.uiElements.filterContainer.on("click", "[data-navigate-to]", function (e) {
            e.preventDefault();
            var $target = $(e.target).closest("tr");
            var userId = parseInt($target.closest("tr").attr("data-navigate-to"));
            _this._args.args.userIds = [];
            _this._args.args.userIds.push(userId);
            _this._args.args.raceOddId = null;
            _this._args.args.horseId = null;
            _this.highlightItems(_this._args.args);
            $target.closest("tbody").find("tr").removeClass("active");
            $target.closest("tr").addClass("active");
        });
        this.uiElements.container.on("click", "[data-back]", function (e) {
            e.preventDefault();
            var $target = $(e.target);
            var $sliderContainer = $target.parent().children(".slider-container");
            var $elements = $sliderContainer.find(".slider-item");
            var $currentEl = $elements.not(":hidden");
            $currentEl.toggle(false);
            var $prev = $currentEl.prev(".slider-item");
            if ($prev.length == 0) {
                $prev = $elements.last();
            }
            $prev.toggle(true);
        });
        this.uiElements.container.on("click", "[data-forward]", function (e) {
            e.preventDefault();
            var $target = $(e.target);
            var $sliderContainer = $target.parent().children(".slider-container");
            var $elements = $sliderContainer.find(".slider-item");
            var $currentEl = $elements.not(":hidden");
            var $next = $currentEl.next(".slider-item");
            if ($next.length == 0) {
                $next = $elements.first();
            }
            $currentEl.toggle(false);
            $next.toggle(true);
        });
    }
    reportMapHandler.prototype.addMapsScript = function () {
        var _this = this;
        if (!document.querySelectorAll("[src=\"" + this._args.googleMapsUrl + "\"]").length) {
            var googleScript = Object.assign(document.createElement('script'), {
                type: 'text/javascript',
                src: this._args.googleMapsUrl,
                onload: function () { return _this.initMap(); }
            });
            document.body.appendChild(googleScript);
        }
        else {
            this.initMap();
        }
    };
    reportMapHandler.prototype.initMap = function () {
        this.map = new google.maps.Map(document.getElementById('map'), {
            maxZoom: 18,
            minZoom: 4
        });
        var args = {
            raceId: this._args.args.raceId
        };
        this.updateMarkers(args);
    };
    reportMapHandler.prototype.updateMarkers = function (args) {
        var _this = this;
        $.post(this._args.getItemsUrl, args, function (data) {
            _this._args.args = data.args;
            _this.clearMap();
            _this.map.setZoom(12);
            if (data.items.length == 0) {
                $("#map").toggle(false);
                _this.uiElements.messageContainer.toggle(true);
            }
            else {
                $("#map").css("visibility", "");
            }
            data.items.forEach(function (item, index) {
                var exists = data.items.filter(function (k, i) {
                    var tolerance = 0.0001;
                    return Math.hypot(k.latitude - item.latitude, k.longitude - item.longitude) <= tolerance;
                });
                var $template = "";
                if (exists.length > 1) {
                    var slides_1 = "";
                    $template = "<a href = 'javascript:void(0);' class='' data-back='1' > " +
                        "<i class='fas fa-angle-left mr-2'></i>" +
                        "Previous" +
                        "</a>" +
                        "<a href='javascript:void(0);' class='float-right' data-forward='1'>" +
                        "Next" +
                        "<i class='fas fa-angle-right ml-2'></i>" +
                        "</a>";
                    exists.forEach(function (k, j) {
                        if (j == 0) {
                            k.display = true;
                        }
                        if (j != 0) {
                            k.removed = true;
                        }
                        slides_1 += _this.itemTemplate(k);
                    });
                    $template += "<div class='slider-container'>" +
                        slides_1;
                }
                else {
                    item.display = true;
                    $template = _this.itemTemplate(item);
                }
                if (!item.removed) {
                    var infowindow_1 = new google.maps.InfoWindow({
                        content: "<div class='modal-map'>" +
                            $template +
                            "</div>"
                    });
                    var title = exists.length > 1 ? exists.length.toString() : item.login + " " + "(" + item.updatedDate + ")";
                    var marker_1 = new google.maps.Marker({
                        position: new google.maps.LatLng(item.latitude, item.longitude),
                        map: _this.map,
                        label: {
                            text: title,
                            fontSize: "15px",
                            fontWeight: "bold"
                        },
                        title: title
                    });
                    marker_1.connectedItems = exists.length > 0 ? exists : [item];
                    marker_1.addListener('click', function (event) {
                        infowindow_1.open(_this.map, marker_1);
                    });
                    _this.markers.push(marker_1);
                }
            });
            if (!_this.clusterer) {
                _this.clusterer = new MarkerClusterer(_this.map, _this.markers, {
                    imagePath: 'https://github.com/googlearchive/js-marker-clusterer/raw/gh-pages/images/m',
                    maxZoom: 18
                });
            }
            else {
                _this.clusterer.addMarkers(_this.markers);
            }
            var bounds = new google.maps.LatLngBounds();
            for (var i = 0; i < _this.markers.length; i++) {
                bounds.extend(_this.markers[i].position);
            }
            _this.map.fitBounds(bounds);
            _this.highlightItems(args);
        });
    };
    reportMapHandler.prototype.clearMap = function () {
        this.markers.forEach(function (marker, inde) {
            marker.setMap(null);
        });
        if (this.clusterer) {
            this.clusterer.clearMarkers();
        }
        this.markers = [];
    };
    reportMapHandler.prototype.highlightItems = function (args) {
        var resultMarkers = this.markers;
        if (args.raceOddId) {
            resultMarkers = resultMarkers.filter(function (val, index, arr) {
                return (val.connectedItems.filter(function (v, i) { return v.raceOddId == args.raceOddId; }).length > 0);
            });
        }
        if (args.horseId) {
            resultMarkers = resultMarkers.filter(function (val, index, arr) {
                return (val.connectedItems.filter(function (v, i) { return v.horseId == args.horseId; }).length > 0);
            });
        }
        if (args.userIds && args.userIds.length > 0) {
            resultMarkers = resultMarkers.filter(function (val, index, arr) {
                return (val.connectedItems.filter(function (v, i) { return args.userIds.indexOf(v.userId) > -1; }).length > 0);
            });
        }
        if (resultMarkers.length > 0) {
            this.map.setCenter(resultMarkers[0].position);
        }
        resultMarkers.forEach(function (marker, index, marks) {
            marker.setAnimation(google.maps.Animation.BOUNCE);
            setTimeout(function () {
                marker.setAnimation(null);
            }, 1000);
        });
    };
    return reportMapHandler;
}());
var mapViewModel = (function () {
    function mapViewModel() {
    }
    return mapViewModel;
}());
var mapViewItemModel = (function () {
    function mapViewItemModel() {
    }
    return mapViewItemModel;
}());
var horseOddMapModel = (function () {
    function horseOddMapModel() {
    }
    return horseOddMapModel;
}());
var reportMapArgs = (function () {
    function reportMapArgs() {
    }
    return reportMapArgs;
}());
var reportMapOptions = (function () {
    function reportMapOptions() {
    }
    return reportMapOptions;
}());
var testRecommendationSendHandler = (function () {
    function testRecommendationSendHandler(container, horsesUrl, racesUrl) {
        var _this = this;
        this.uiElements = {
            container: null,
            date: null,
            track: null,
            race: null,
            horse: null
        };
        this.uiElements.container = $(container);
        this.uiElements.date = $(".datepicker", this.uiElements.container);
        this.uiElements.track = $("#TrackId", this.uiElements.container);
        this.uiElements.race = $("#RaceId", this.uiElements.container);
        this.uiElements.horse = $("#HorseId", this.uiElements.container);
        this.horsesUrl = horsesUrl;
        this.racesUrl = racesUrl;
        var onDateChanged = function () { return _this.updateRaces(); };
        this.uiElements.date.datepicker({ dateFormat: "mm/dd/yy", onClose: onDateChanged });
        this.subscribeToEvents();
    }
    testRecommendationSendHandler.prototype.updateRaces = function () {
        var _this = this;
        var date = this.uiElements.date.val();
        var track = this.uiElements.track.val();
        var args = {
            date: date,
            trackId: track
        };
        $.post(this.racesUrl, args, function (data) {
            _this.updateDropdown(_this.uiElements.race, data);
        });
    };
    testRecommendationSendHandler.prototype.subscribeToEvents = function () {
        var _this = this;
        this.uiElements.track.change(function () {
            _this.updateRaces();
        });
        this.uiElements.race.change(function () {
            $.post(_this.horsesUrl, { raceId: _this.uiElements.race.val() }, function (data) {
                _this.updateDropdown(_this.uiElements.horse, data);
            });
        });
    };
    testRecommendationSendHandler.prototype.updateDropdown = function (dropdown, selectList) {
        var $dropdown = $(dropdown);
        var value = $dropdown.val();
        $dropdown.val("");
        var firstOption = $dropdown.find("option")[0];
        $dropdown.html("");
        $dropdown.append(firstOption);
        $.each(selectList, function (ind, val) {
            $dropdown.append($("<option></option>").val(val.value).text(val.text));
        });
        $dropdown.val(value);
    };
    return testRecommendationSendHandler;
}());
var trackEdit = (function () {
    function trackEdit(container) {
        this.uiElements = {
            container: null,
            toteUserIds: null,
            trackNameTxtBox: null
        };
        this.uiElements.container = $(container);
        this.uiElements.toteUserIds = $("#ToteUserIds", this.uiElements.container);
        this.uiElements.toteUserIds.select2({ dropdownAutoWidth: true, containerCssClass: '', placeholder: '' });
        this.subscribeToEvents();
    }
    trackEdit.prototype.subscribeToEvents = function () {
    };
    return trackEdit;
}());
var traderOdds = (function () {
    function traderOdds(args) {
        this.uiElements = {
            container: null,
            listContainer: null
        };
        this._args = args;
        this.timers = new timeoutStorage();
        this.startConnection();
        this.uiElements.container = $(args.container);
        this.uiElements.listContainer = $(".items-container", this.uiElements.container);
        this.subscribeToEvents();
        this.refresh(this._args, true);
    }
    traderOdds.prototype.subscribeToEvents = function () {
        var _this = this;
        this.uiElements.container.on("click", "[data-race-odd-id]", function (e) {
            e.preventDefault();
            var $td = $(e.target).closest("td");
            var userId = $td.attr("data-user-id");
            var raceId = $td.attr("data-race-id");
            var raceOddId = $td.attr("data-race-odd-id");
            var horseId = $td.attr("data-horse-odd-id");
            var dialog = appDialogShow({
                dialogClass: "dialog-750px",
                body: "<p>Loading...</p>", buttons: [
                    {
                        text: "Close",
                        buttonClass: 'btn-secondary',
                        click: function () {
                            dialog.close();
                        }
                    }
                ]
            });
            dialog.container.on("shown.bs.modal", function () {
                $.get(_this._args.historyPopupUrl, {
                    raceId: raceId,
                    userId: userId,
                    horseId: horseId,
                    raceOddId: raceOddId
                }, function (data) {
                    dialog.container.find(".modal-body").html(data);
                    site.validators.refreshValidators(dialog.container);
                    if (dialog.container.find("form").length == 0) {
                        $(".btn-primary", dialog.container).prop("disabled", true);
                    }
                    else {
                        $(".btn-primary", dialog.container).prop("disabled", false);
                    }
                });
            });
        });
        this.uiElements.container.on("click", "[data-horse-odd]", function (e) {
            e.preventDefault();
            $.get(_this._args.popupUrl, function (data) {
                var dialog = appDialogShow({
                    body: data, buttons: [
                        {
                            text: "Close",
                            buttonClass: 'btn-secondary',
                            click: function () {
                                dialog.close();
                            }
                        }
                    ]
                });
            });
        });
    };
    traderOdds.prototype.startConnection = function () {
        var _this = this;
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl("/raceodds?raceId=" + this._args.raceId)
            .build();
        this.connection.start().catch(function (err) { return console.log(err); });
        var refreshAction = function () { return _this.refresh(); };
        this.connection.onclose(function () {
            refreshAction();
            _this.startConnection();
        });
        this.connection.on("UpdateRaceInfo", function (raceId, betLocationId, bookmakerId, userId) {
            if (_this._args.raceId == raceId) {
                _this._args.bookmakerId = bookmakerId;
                _this._args.betLocationId = betLocationId;
                _this._args.userId = userId;
                refreshAction();
            }
        });
    };
    traderOdds.prototype.refresh = function (args, initial) {
        var _this = this;
        if (args === void 0) { args = null; }
        if (initial === void 0) { initial = false; }
        $.post(this._args.getUrl, args == null ? this._args : args, function (data) {
            _this.silentRefresh(data, initial);
        });
    };
    traderOdds.prototype.silentRefresh = function (data, initial) {
        var _this = this;
        if (initial === void 0) { initial = false; }
        this.silentRefreshHorses(data);
        this.silentRefreshOdds(data);
        this.getMaxOdds();
        data.raceAssignments.forEach(function (assignment, index) {
            var isExist = _this.timers.isExists(assignment);
            if (isExist) {
                _this.timers.remove(assignment, function (assignment) { _this.removeHighlight(assignment); });
                _this.timers.startTimeout(assignment, function (assignment) { _this.addHighlight(assignment); });
            }
            else {
                if (!initial) {
                    _this.removeHighlight(assignment);
                }
                _this.timers.startTimeout(assignment, function (assignment) { _this.addHighlight(assignment); });
            }
        });
    };
    traderOdds.prototype.updatePercentage = function () {
        var $tableTrs = $("th[data-head-user-id]", this.uiElements.listContainer);
        $.each($tableTrs, function (index, val) {
            var $tr = $(val);
            var userId = $tr.attr("data-head-user-id");
            var bookmakerId = $tr.attr("data-header-bookmaker-id");
            var betLocationId = $tr.attr("data-header-location-id");
            var allTds = $("td[data-bookmaker-td='" + bookmakerId + "'][data-bet-location-td='" + betLocationId + "'][data-user-id='" + userId + "']");
            var sum = 0;
            $.each(allTds, function (i, v) {
                var $td = $(v);
                if ($td.is(":visible")) {
                    var odd = parseFloat($td.attr("data-odd"));
                    if (odd != 0) {
                        sum += 1 / (odd + 1);
                    }
                }
            });
            var res = sum * 100;
            if (res > 0) {
                $("td[data-percentage-bookmaker-id='" + bookmakerId + "'][data-percentage-location-id='" + betLocationId + "'][data-user-percentage-id='" + userId + "']").html(res.toFixed(2) + "%");
            }
            else {
                $("td[data-percentage-bookmaker-id='" + bookmakerId + "'][data-percentage-location-id='" + betLocationId + "'][data-user-percentage-id='" + userId + "']").html("");
            }
        });
    };
    traderOdds.prototype.silentRefreshHorses = function (model) {
        var _this = this;
        model.horses.forEach(function (v, ind, arr) {
            var $horseTr = $("[data-horse-id='" + v.horseId + "']", _this.uiElements.listContainer);
            if (v.excluded) {
                $horseTr.css("display", "none");
            }
            else {
                $horseTr.css("display", "");
            }
        });
    };
    traderOdds.prototype.silentRefreshOdds = function (model) {
        model.raceAssignments.forEach(function (assignment, ind, arr) {
            assignment.odds.forEach(function (odd, i, odds) {
                var $upd = $("[data-horse-odd-id='" + odd.horseId + "'][data-assignment-id='" + assignment.id + "'][data-user-id='" + assignment.userId + "']");
                $upd.attr("data-race-odd-id", odd.raceOddId);
                if ($upd.length > 0) {
                    if (odd.denominator != 0 && odd.numerator != 0) {
                        $upd.html("<span>" + odd.numerator + "/" + odd.denominator + "</span>");
                        $upd.closest("td").attr("data-odd", odd.numerator / odd.denominator);
                    }
                    else {
                        $upd.html("<span>" + "</span>");
                        $upd.closest("td").attr("data-odd", 0);
                    }
                }
            });
        });
    };
    traderOdds.prototype.getMaxOdds = function () {
        $("[data-horse-odd-id]>span").css("color", "");
        var $horseTrs = $("[data-horse-id]", this.uiElements.listContainer);
        $.each($horseTrs, function (ind, val) {
            var $tds = $(val).find("[data-odd]");
            var horseOdds = [];
            $.each($tds, function (i, v) {
                var odd = $(v).attr("data-odd");
                var res = 0;
                if (odd) {
                    res = parseFloat(odd);
                    ;
                }
                horseOdds.push(res);
            });
            var maxOdd = Math.max.apply(Math, horseOdds);
            $.each($tds, function (i, v) {
                var odd = $(v).attr("data-odd");
                var res = 0;
                if (odd) {
                    res = parseFloat(odd);
                    ;
                }
                if (maxOdd == res) {
                    $(v).find("span").css("color", "#00862d;");
                }
            });
        });
        this.updatePercentage();
    };
    traderOdds.prototype.addHighlight = function (assignment) {
        var odds = assignment.odds.filter(function (odd, ind) {
            return odd.numerator != 0 && odd.denominator != 0 && odd.excluded == false;
        });
        if (odds.length > 0) {
            var $dataTds = $("td[data-bookmaker-td='" + assignment.bookmakerId + "'][data-bet-location-td='" + assignment.betLocationId + "'][data-user-id='" + assignment.userId + "']");
            var $headTds = $("th[data-head-user-id='" + assignment.userId + "'][data-header-location-id='" + assignment.betLocationId + "'][data-header-bookmaker-id='" + assignment.bookmakerId + "']");
            var $bottomTrs = $("td[data-user-percentage-id='" + assignment.userId + "'][data-percentage-location-id='" + assignment.betLocationId + "'][data-percentage-bookmaker-id='" + assignment.bookmakerId + "']");
            $dataTds.addClass("highlighted-col");
            $headTds.addClass("highlighted-col");
            $bottomTrs.addClass("highlighted-col");
        }
    };
    traderOdds.prototype.removeHighlight = function (assignment) {
        var $dataTds = $("td[data-bookmaker-td='" + assignment.bookmakerId + "'][data-bet-location-td='" + assignment.betLocationId + "'][data-user-id='" + assignment.userId + "']");
        var $headTds = $("th[data-head-user-id='" + assignment.userId + "'][data-header-location-id='" + assignment.betLocationId + "'][data-header-bookmaker-id='" + assignment.bookmakerId + "']");
        var $bottomTrs = $("td[data-user-percentage-id='" + assignment.userId + "'][data-percentage-location-id='" + assignment.betLocationId + "'][data-percentage-bookmaker-id='" + assignment.bookmakerId + "']");
        $dataTds.removeClass("highlighted-col");
        $headTds.removeClass("highlighted-col");
        $bottomTrs.removeClass("highlighted-col");
    };
    return traderOdds;
}());
var raceOddsModel = (function () {
    function raceOddsModel() {
    }
    return raceOddsModel;
}());
var raceHorseModel = (function () {
    function raceHorseModel() {
    }
    return raceHorseModel;
}());
var raceAssignmentModel = (function () {
    function raceAssignmentModel() {
    }
    return raceAssignmentModel;
}());
var raceRunnerModel = (function () {
    function raceRunnerModel() {
    }
    return raceRunnerModel;
}());
var horseOddModel = (function () {
    function horseOddModel() {
    }
    return horseOddModel;
}());
var raceOddsArgs = (function () {
    function raceOddsArgs() {
    }
    return raceOddsArgs;
}());
var traderOddsArgs = (function () {
    function traderOddsArgs() {
    }
    return traderOddsArgs;
}());
var timeoutStorage = (function () {
    function timeoutStorage() {
        this.timeouts = new Array();
    }
    timeoutStorage.prototype.startTimeout = function (assignment, callback) {
        var isBefore = moment().utc().isBefore(moment.utc(assignment.raceStartDateUtc));
        var odds = assignment.odds.filter(function (odd, ind) {
            return odd.numerator != 0 && odd.denominator != 0 && odd.excluded == false;
        });
        if (isBefore && assignment.tradeUIUpdateTimeoutMinutes != null && odds.length > 0) {
            var func = function () { callback(assignment); };
            var timer = window.setTimeout(func, 1000 * 60 * assignment.tradeUIUpdateTimeoutMinutes);
            this.timeouts.push({ assignment: assignment, timerId: timer });
        }
    };
    timeoutStorage.prototype.add = function (item) {
        var isExists = this.timeouts.find(function (v) {
            return v.timerId == item.timerId;
        });
        if (!isExists) {
            this.timeouts.push(item);
        }
        ;
    };
    timeoutStorage.prototype.remove = function (assignment, callback) {
        var itemToRemove = this.timeouts.find(function (v) {
            return v.assignment.userId == assignment.userId && v.assignment.betLocationId == assignment.betLocationId && v.assignment.bookmakerId == assignment.bookmakerId;
        });
        if (itemToRemove) {
            clearTimeout(itemToRemove.timerId);
            this.timeouts.splice(this.timeouts.indexOf(itemToRemove), 1);
            callback(assignment);
        }
    };
    timeoutStorage.prototype.isExists = function (assignment) {
        var itemToRemove = this.timeouts.find(function (v) {
            return v.assignment.userId == assignment.userId && v.assignment.betLocationId == assignment.betLocationId && v.assignment.bookmakerId == assignment.bookmakerId;
        });
        return itemToRemove != null;
    };
    timeoutStorage.prototype.removeByTimeout = function (timeoutId) {
        var itemToRemove = this.timeouts.find(function (v) {
            return v.timerId == timeoutId;
        });
        if (itemToRemove) {
            clearTimeout(itemToRemove.timerId);
            this.timeouts.splice(this.timeouts.indexOf(itemToRemove), 1);
        }
    };
    return timeoutStorage;
}());
var timeoutStorageItem = (function () {
    function timeoutStorageItem() {
    }
    return timeoutStorageItem;
}());
var traderOddsHistory = (function () {
    function traderOddsHistory(args) {
        this._chart = null;
        this.uiElements = {
            container: null,
            chartContainer: null
        };
        this._args = args;
        this.uiElements.container = $(args.container);
        this.uiElements.chartContainer = $("#chartContainer", this.uiElements.container);
        this.initChart();
    }
    traderOddsHistory.prototype.initChart = function () {
        var _this = this;
        $.get(this._args.historyDataUrl, {
            raceId: this._args.raceId,
            horseId: this._args.horseId,
            raceOddId: this._args.raceOddId,
            horseName: this._args.horseName,
            userId: this._args.userId
        }, function (data) {
            var ctx = _this.uiElements.chartContainer[0].getContext('2d');
            var dataCopy = data;
            var chartTooltip = {
                borderWidth: 0.5,
                bodySpacing: 10,
                xPadding: 15,
                yPadding: 15,
                cornerRadius: 0.15,
                displayColors: false,
                callbacks: {
                    label: function (tooltipItem, data) {
                        var element = dataCopy.items[tooltipItem.dataIndex];
                        return "Date: " + moment(element.createdDate).format("MM/DD/YYYY hh:mm A") + "; Bet: " + element.numerator + "/" + element.denominator;
                    }
                }
            };
            var chartConfig = {
                type: 'line',
                data: {
                    datasets: [{
                            label: "Odds for " + _this._args.horseName,
                            data: _this.getData(data),
                            backgroundColor: 'rgb(255, 99, 132)',
                            borderColor: 'rgb(255, 99, 132)',
                            borderWidth: 1,
                            lineTension: 0.5
                        }]
                },
                options: {
                    scales: {
                        xAxes: [{
                                type: 'time',
                                time: {
                                    unit: 'minute'
                                }
                            }]
                    },
                    plugins: {
                        tooltip: chartTooltip
                    }
                }
            };
            _this._chart = new Chart(ctx, chartConfig);
        });
    };
    traderOddsHistory.prototype.getLabels = function (data) {
        var result = [];
        data.items.forEach(function (value, index) {
            result.push(moment(value.createdDate).format("MM/DD/YYYY hh:mm A") + " - " + value.numerator + "/" + value.denominator);
        });
        return result;
    };
    traderOddsHistory.prototype.getData = function (data) {
        var result = [];
        data.items.forEach(function (value, index) {
            result.push({ x: moment(value.createdDate).format("hh:mm A"), y: value.numerator / value.denominator });
        });
        return result;
    };
    return traderOddsHistory;
}());
var horseOddHistoryArgs = (function () {
    function horseOddHistoryArgs() {
    }
    return horseOddHistoryArgs;
}());
var horseOddHistoryItem = (function () {
    function horseOddHistoryItem() {
    }
    return horseOddHistoryItem;
}());
var horseOddHistoryModel = (function () {
    function horseOddHistoryModel() {
    }
    return horseOddHistoryModel;
}());
//# sourceMappingURL=/app-out/app.js.map